import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { BASE_URL } from '../../../config/axios';
import { CSSForSelect, CSSForSelect15vWWidth, CSSForSelect23vWWidth, CSSForSelectModern, formatCurrencyIndian, handleErrorToast, Lock, ProgressModal, sortProjects } from '../../CustomFunctions';
import { ToastContainer, toast } from 'react-toastify';
import { formattedDateLong } from '../../Date';
import Dashboardnavbar from '../../../layout/Dashboardnavbar';
import AdminInventoryitemlist from '../AdminSiteManagement/AdminInventoryitemlist';
import { SearchSmall, SearchBig, UpdatePencil, AddwithWhiteCircle, DropdownArrow, Attachment, DocumentIcon, DocumentfOLDIcon } from '../../AllSvg';
import { Projects } from '../../FilterDropdown';
import { UploadInventory, UploadItemsBulk } from '../BulkModals';
import Select, { components } from "react-select";
import { axiosInstance2 } from '../../../config/axiosInstance';
import { AlertCircle, Briefcase, Building2, Calendar, ChevronDown, ChevronRight, ChevronUp, FileText, Filter, Folder, Hash, IndianRupee, Loader, Package, Paperclip, Save, Search, Sparkles, Tag, Trash2, User, X } from 'lucide-react';
import { List } from 'antd';
import '../ProjectView.css';
import { AddDynamicButton } from '../Components/modernbuttons/AddDynamicButton';


// !  **************  Inventory Components Start **************  ! //

// const AddSiteInventory = ({ getInventory, p_id }) => {
//     const [show, setShow] = useState(false);
//     const [projectList, setProjectList] = useState([]);
//     const projectID = sessionStorage.getItem('sitemanagement_project')

//     const role = sessionStorage.getItem('sitemanagement_role');
//     const siteRole = sessionStorage.getItem("sitemanagement_role");
//     const siteempId = sessionStorage.getItem("sitemanagement_emp_id");
//     const handleClose = () => {
//         setShow(false);
//         setErrors({});
//         setFormData({
//             emp_code: null,
//             project: projectID ? projectID : p_id ? p_id : "null",
//             description: "",
//             quantity: "",
//             upload_attachment: "null",


//             item_id_multiple: [],
//             rate_per_item: "",
//             purchase_date: null,
//             // remaning_quantity: "",
//             // distributed_quantity: "",
//             // sub_company: sessionStorage.getItem('company_id')
//         })
//     }

//     const handleShow = () => {

//         getEmployee();
//         getItem();
//         setShow(true)
//     };

//     const [formData, setFormData] = useState({
//         item_id: "",
//         emp_code: null,
//         project: projectID ? projectID : p_id ? p_id : "null",
//         description: "",
//         quantity: "",
//         rate_per_item: "",
//         upload_attachment: "null",
//         item_id_multiple: [],

//         purchase_date: null,
//         // remaning_quantity: "",
//         // distributed_quantity: "",
//         // sub_company: sessionStorage.getItem('company_id')
//     });
//     const [status, setStatus] = useState(0);

//     const getProjectdata = async () => {
//         try {
//             const resUrl = await axios.get(`${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${siteRole === "AuthorityEngineer" ? siteempId : "null"}/null/${siteRole === "DataEntryOperator" ? siteempId : "null"}/null/`);
//             setProjectList(resUrl.data);
//             setStatus(resUrl.status)
//         } catch (error) {
//             toast.error(error)
//         }
//     };


//     useEffect(() => {
//         if (show === true && projectList.length === 0) {
//             getProjectdata();
//         }
//     }, [siteRole, show, siteempId, projectList]);



//     const [itemlist, setItemList] = useState([]);

//     const getItem = async () => {

//         setBuffering(true); //buffering logic // Start Buffering
//         try {
//             const pro = await axios.get(`${BASE_URL}/siteproject/siteinventoryitem/`);
//             setItemList(pro.data);

//         } catch (err) {
//             //toast Logic
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false);// End Buffering
//         }

//     }




//     //******************Valedation Start********************* */

//     const [errors, setErrors] = useState({});
//     const [inputState, setInputState] = useState({});
//     const [isSubmitted, setIsSubmitted] = useState(false);


//     const validateForm = () => {
//         const newErrors = {};
//         const requiredFields = [
//             "description",
//             "quantity",
//             "rate_per_item",
//             "project",

//         ];
//         if (formData.item_id_multiple.length === 0) {
//             newErrors.item_id_multiple = `Item is required field`
//         }
//         if (formData.purchase_date) {
//             const selectedDate = new Date(formData.purchase_date);
//             const today = new Date();
//             today.setHours(0, 0, 0, 0);

//             const selectedDateObj = new Date(selectedDate);
//             selectedDateObj.setHours(0, 0, 0, 0);

//             if (selectedDateObj > today) {
//                 newErrors.purchase_date = "Future date is not allowed";
//                 return;
//             }
//         }

//         requiredFields.forEach((field) => {
//             if (!formData[field] || formData[field] === "null") {

//                 newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
//                     } is required !`;

//             }
//         });

//         setErrors(newErrors);
//         setIsSubmitted(true);
//         return Object.keys(newErrors).length === 0;
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         if (name === "purchase_date") {
//             const today = new Date().toISOString().split("T")[0];

//             if (value > today) {
//                 setErrors({
//                     ...errors,
//                     purchase_date: "Future date is not allowed",
//                 });
//                 return;
//             }
//         }


//         setInputState({
//             ...inputState,
//             [name]: value.trim() ? "green" : "",
//         });

//         setFormData((prevFormData) => {
//             const updatedFormData = {
//                 ...prevFormData,
//                 [name]: value,
//             };

//             if (name === "emp_code") {
//                 const selectedprojectList = projectList.find(emp => emp.emp_code === value);
//                 if (selectedprojectList) {
//                     updatedFormData.name = selectedprojectList.name;
//                 } else {
//                     updatedFormData.name = null;
//                 }
//             }

//             return updatedFormData;
//         });

//         setErrors((prevErrors) => {
//             const updatedErrors = { ...prevErrors };
//             if (value.trim()) {
//                 delete updatedErrors[name];
//             }
//             return updatedErrors;
//         });

//         if (value.trim()) {
//             setErrors((prevErrors) => {
//                 const updatedErrors = { ...prevErrors };
//                 delete updatedErrors[name];
//                 return updatedErrors;
//             });
//         }
//     };

//     const [employeeList, setEmployeeList] = useState([]);

//     const getEmployee = async () => {
//         setBuffering(true); //buffering logic // Start Buffering
//         try {
//             const pro = await axios.get(`${BASE_URL}/siteproject/employeefilterbyproject/${formData.project}/null/`);
//             setEmployeeList(pro.data);

//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false);// End Buffering
//         }
//     };
//     useEffect(() => {
//         getEmployee(formData.project);
//     }, [formData.project]);


//     const [buffer, setBuffering] = useState(true); //buffering logic



//     //******************Valedation End*********************** */

//     const [loading, setLoading] = useState(false);

//     const handleFormSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true);
//             const loadingToastId = toast.loading("Loading: Please wait...");

//             try {
//                 const payload = new FormData();

//                 formData.item_id_multiple.forEach((id) => {
//                     payload.append("item_id_multiple", id);
//                 });
//                 payload.append("emp_code", formData.emp_code || null);
//                 payload.append("project", formData.project);
//                 payload.append("description", formData.description);
//                 payload.append("quantity", formData.quantity);
//                 payload.append("rate_per_item", formData.rate_per_item);
//                 payload.append("purchase_date", formData.purchase_date || null);

//                 if (formData.upload_attachment) {
//                     payload.append("upload_attachment", formData.upload_attachment);
//                 }

//                 const res = await axios.post(
//                     `${BASE_URL}/siteproject/siteinventory/`,
//                     payload,
//                     {
//                         headers: {
//                             "Content-Type": "multipart/form-data",
//                         },
//                     }
//                 );

//                 if (res.status === 200) {
//                     await getInventory();
//                     toast.dismiss(loadingToastId);
//                     handleClose();
//                 } else {
//                     toast.dismiss(loadingToastId);
//                     toast.error("Failed to add data!");
//                 }

//             } catch (err) {
//                 toast.dismiss(loadingToastId);
//                 handleErrorToast(err);
//             } finally {
//                 setLoading(false);
//             }
//         }
//     };


//     const projectOptions = projectList
//         ?.sort((a, b) =>
//             a.project_short_name.localeCompare(b.project_short_name, "en", {
//                 ignorePunctuation: true,
//             })
//         )
//         .map((i) => ({
//             value: i.id,
//             label: `${i.site_prcode} ${i.project_short_name}`,
//         }));

//     const itemOptions = itemlist
//         ?.sort((a, b) =>
//             a.item_name.localeCompare(b.item_name, "en", {
//                 ignorePunctuation: true,
//             })
//         )
//         .map((i) => ({
//             value: i.id,
//             label: i.item_name,
//         }));


//     const employeeOptions = employeeList
//         ?.sort((a, b) =>
//             a.emp_code.localeCompare(b.emp_code, "en", {
//                 ignorePunctuation: true,
//             })
//         )
//         .map((i) => ({
//             value: i.id,
//             label: `${i.emp_code} - ${i.name}`,
//         }));

//     const [docNames, setDocNames] = useState();

//     const handleFileChange = (e) => {
//         const file = e.target.files[0];

//         if (file) {
//             const symbols = "!@#$%^&*()_-+=";
//             const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
//             const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
//             const numbers = "0123456789";
//             const now = new Date();
//             const date = now
//                 .toLocaleDateString("en-GB")
//                 .split("/")
//                 .reverse()
//                 .join("-"); // Format: YYYY-MM-DD
//             const time = now
//                 .toLocaleTimeString("en-GB", { hour12: false })
//                 .replace(/:/g, "-"); // Format: HH-MM-SS
//             const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
//             let randomCode = "";
//             for (let i = 0; i < 8; i++) {
//                 const randomIndex = Math.floor(Math.random() * allChars.length);
//                 randomCode += allChars[randomIndex];
//             }
//             const customFileName = `Aimantra ${date} ${time}_${randomCode} ${file.name}`;
//             const customFile = new File([file], customFileName, { type: file.type });

//             setFormData({
//                 ...formData,
//                 upload_attachment: customFile,
//             });
//             setDocNames(customFileName);
//         } else {
//             setDocNames("");
//         }
//     };

//     const handleFileClear = (name) => {
//         setFormData({
//             ...formData,
//             upload_attachment: null,
//         });
//         setDocNames("");
//     };

//     const Option = (props) => (
//         <components.Option {...props}>

//             <label title="Star" class="star">
//                 <input id="star-checkbox" checked={props.isSelected}
//                     onChange={() => null} className="checkbox" type="checkbox" />
//                 <div className="svg-container">
//                     <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="svg-outline"
//                         viewBox="0 0 24 24"
//                     >
//                         <path
//                             d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5ZM12 4.75L14 9.33L18.7 9.75L15 13.07L16.18 17.75L12 15.16L7.82 17.75L9 13.07L5.3 9.75L10 9.33L12 4.75Z"
//                         ></path>
//                     </svg>
//                     <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="svg-filled"
//                         viewBox="0 0 24 24"
//                     >
//                         <path
//                             d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5Z"
//                         ></path>
//                     </svg>
//                     <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         height="100"
//                         width="100"
//                         className="svg-celebrate"
//                     >
//                         <circle r="2" cy="50" cx="50" className="particle"></circle>
//                         <circle r="2" cy="50" cx="50" className="particle"></circle>
//                         <circle r="2" cy="50" cx="50" className="particle"></circle>
//                         <circle r="2" cy="50" cx="50" className="particle"></circle>
//                         <circle r="2" cy="50" cx="50" className="particle"></circle>
//                         <circle r="2" cy="50" cx="50" className="particle"></circle>
//                         <circle r="2" cy="50" cx="50" className="particle"></circle>
//                         <circle r="2" cy="50" cx="50" className="particle"></circle>
//                     </svg>
//                 </div>
//             </label>
//             {props.label}
//         </components.Option>
//     );



//     const MenuList = (props) => {
//         const { options, selectProps } = props;

//         const filteredOptions = options.filter(
//             (opt) => opt.label.toLowerCase() !== "other"
//         );

//         const selectedValues = selectProps.value?.map((i) => i.value) || [];
//         const filteredValues = filteredOptions.map((i) => i.value);

//         const isAllSelected = filteredValues.every((val) =>
//             selectedValues.includes(val)
//         );

//         const handleToggle = () => {
//             if (isAllSelected) {
//                 const preserveOther = selectProps.value?.filter(
//                     (i) => i.label.toLowerCase() === "other"
//                 ) || [];
//                 selectProps.onChange(preserveOther);
//             } else {
//                 const preserveOther = selectProps.value?.filter(
//                     (i) => i.label.toLowerCase() === "other"
//                 ) || [];
//                 selectProps.onChange([...filteredOptions, ...preserveOther]);
//             }
//         }

//         return (
//             <components.MenuList {...props}>
//                 <button
//                     type="button"
//                     onClick={handleToggle}
//                     style={{
//                         width: "100%",
//                         padding: "6px 0",
//                         cursor: "pointer",
//                         fontWeight: "600",
//                         borderBottom: "1px solid #e3e3e3",
//                         background: "white"
//                     }}
//                 >
//                     {isAllSelected ? "Unselect All" : "Select All"}
//                 </button>

//                 {props.children}
//             </components.MenuList>
//         );
//     };


//     const handleChangecc = (selected) => {
//         const item_id_multiple =
//             selected.length > 0 ? selected.map((item) => item.value) : "";
//         setFormData((prevState) => ({
//             ...prevState,
//             item_id_multiple,
//         }));
//     };
//     useEffect(() => {
//         if (formData.project) {

//             setFormData(prev => ({
//                 ...prev,
//                 emp_code: null,
//             }));
//         }
//     }, [formData.project]);


//     return (
//         <>
//             <button title="Site Inventory" className="upload-svg" onClick={handleShow}>
//                 <AddwithWhiteCircle />
//                 {" "} Site Inventory
//             </button>

//             <Modal show={show} onHide={handleClose} dialogClassName="model-width60vw">
//                 <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500    font-size-heading ">
//                     <Modal.Title> Add Site Inventory</Modal.Title>
//                 </Modal.Header>
//                 {/* <Modal.Header closeButton>
//                 <Modal.Title>Request Leave</Modal.Title>
//               </Modal.Header> */}
//                 <Modal.Body>
//                     <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

//                     <div className="parent-div">
//                         <div className="bdy-div">
//                             <div className='form-flex-wrap'>

//                                 <div title="Project" className="flex-column form-group-selectt">
//                                     <label className="form-labels  font-weight500    font-size-subheading">
//                                         Site Project<span className="required">{(role === "SiteManagement" || p_id) ? `Read-Only` : `*`}</span>
//                                     </label>
//                                     <br />
//                                     {status === 200 ?
//                                         <Select
//                                             name="project"
//                                             isDisabled={(role === "SiteManagement" || p_id) ? true : false}
//                                             placeholder="Select a Project"
//                                             value={projectOptions?.find(
//                                                 (option) => option.value === formData.project
//                                             )}
//                                             onChange={(selectedOption) => {
//                                                 setFormData({
//                                                     ...formData,
//                                                     project: selectedOption ? selectedOption.value : "null",
//                                                 });

//                                                 setInputState({
//                                                     ...inputState,
//                                                     project: selectedOption ? "green" : "",
//                                                 });
//                                             }}
//                                             styles={CSSForSelect23vWWidth}
//                                             options={projectOptions}
//                                             isSearchable={true}
//                                             isClearable={true}

//                                         />
//                                         :
//                                         <ul style={{ marginTop: "20px", paddingLeft: "0px" }}>
//                                             <li>
//                                                 <div className="loader" style={{ width: "15vw" }}>
//                                                     <div className="child"></div>
//                                                 </div>
//                                             </li>

//                                             <li>
//                                                 <div className="text"></div>
//                                             </li>
//                                         </ul>

//                                     }

//                                     {errors.project && <span className="error-message font-size-text ">{errors.project}</span>}
//                                 </div>
//                                 {formData.project !== "null" &&

//                                     <div title="Employees List" className="flex-column form-group-selectt">
//                                         <label htmlFor="emp_code" className="form-labels  font-weight500    font-size-subheading">
//                                             {role === "SiteManagement" ? "Employee" : "Employee"}
//                                         </label>
//                                         <br />
//                                         <Select
//                                             name="emp_code"
//                                             placeholder="Select an Employee"
//                                             value={
//                                                 employeeOptions?.find(
//                                                     (option) => option.value === formData.emp_code
//                                                 ) || null
//                                             }
//                                             onChange={(selectedOption) => {
//                                                 setFormData((prev) => ({
//                                                     ...prev,
//                                                     emp_code: selectedOption ? selectedOption.value : null,
//                                                 }));

//                                                 setInputState((prev) => ({
//                                                     ...prev,
//                                                     emp_code: selectedOption ? "green" : "",
//                                                 }));
//                                             }}
//                                             options={employeeOptions}
//                                             isSearchable
//                                             isClearable
//                                             styles={CSSForSelect23vWWidth}
//                                         />

//                                         {errors.emp_code && <span className="error-message font-size-text ">{errors.emp_code}</span>}
//                                     </div>
//                                 }

//                                 <div title="List of Items" className="flex-column form-group-selectt">
//                                     <label htmlFor="item_id" className="form-labels  font-weight500    font-size-subheading">
//                                         List of Items<span className="required">*</span>
//                                     </label>
//                                     <br />
//                                     <Select
//                                         options={itemOptions}
//                                         isMulti
//                                         closeMenuOnSelect={false}
//                                         hideSelectedOptions={false}
//                                         components={{ Option, MenuList }}
//                                         placeholder="Select Name"
//                                         onChange={handleChangecc}
//                                         styles={formData.project === "null" ? CSSForSelect23vWWidth : {
//                                             control: (provided) => ({
//                                                 ...provided,
//                                                 width: "54vw",
//                                                 minHeight: '50px',
//                                                 borderRadius: '10px',
//                                                 border: '1px solid #e3e3e3',
//                                                 margin: '10px 0px 20px 0px',
//                                                 color: '#4a4a4a',
//                                                 backgroundColor: '#f7f8fa',
//                                                 padding: '0px 10px',
//                                             }),
//                                             placeholder: (provided) => ({
//                                                 ...provided,
//                                                 color: '#4a4a4a',
//                                             }),
//                                             menu: (provided) => ({
//                                                 ...provided,
//                                                 width: '54vw',
//                                                 borderRadius: '10px',
//                                                 marginTop: '0',
//                                             }),
//                                             singleValue: (provided) => ({
//                                                 ...provided,
//                                                 color: '#4a4a4a',
//                                             }),
//                                             input: (provided) => ({
//                                                 ...provided,
//                                                 color: '#4a4a4a',
//                                             }),

//                                             option: (provided, state) => ({
//                                                 ...provided,
//                                                 backgroundColor: state.isSelected
//                                                     ? "#cfe2ff"
//                                                     : state.isFocused
//                                                         ? "#cfe2ff"
//                                                         : "white",

//                                                 color: "#4a4a4a",
//                                                 padding: "8px 12px",
//                                                 ":active": {
//                                                     backgroundColor: "#cfe2ff",
//                                                 }
//                                             }),
//                                         }}

//                                     />
//                                     {errors.item_id_multiple && <span className="error-message font-size-text ">Required field!</span>}
//                                 </div>



//                                 <div className="flex-column">
//                                     <label htmlFor="description" className="form-labels  font-weight500    font-size-subheading" title='Description'>
//                                         Description<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         type="text"
//                                         id="description"
//                                         name="description"
//                                         placeholder="Name of the description"
//                                         title='Description'
//                                         style={{ width: "54vw" }}
//                                         onChange={handleInputChange}
//                                         value={formData.description}
//                                         className={`form-input ${errors.description ? "error" : inputState.tile ? "success" : ""
//                                             }`}
//                                     />
//                                     {errors.description && (
//                                         <span className="error-message font-size-text ">{errors.description}</span>
//                                     )}
//                                 </div>

//                                 <div className="flex-column">
//                                     <label htmlFor="quantity" className="form-labels  font-weight500    font-size-subheading" title="Quantity">
//                                         Quantity<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         type="number"
//                                         min={0}
//                                         id="quantity"
//                                         name="quantity"
//                                         title="Quantity"
//                                         placeholder="Quantity"
//                                         onChange={handleInputChange}
//                                         onWheel={(e) => e.target.blur()}
//                                         value={formData.quantity}
//                                         className={`form-input width-10vw ${errors.quantity ? "error" : inputState.tile ? "success" : ""
//                                             }`}
//                                     />
//                                     {errors.quantity && (
//                                         <span className="error-message font-size-text ">{errors.quantity}</span>
//                                     )}
//                                 </div>

//                                 <div className="flex-column">
//                                     <label htmlFor="rate_per_item" className="form-labels  font-weight500    font-size-subheading" title='Rate per Item'>
//                                         Rate per Item<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         type="number"
//                                         min={0}
//                                         id="rate_per_item"
//                                         name="rate_per_item"
//                                         title="Rate per Item"
//                                         placeholder=" Rate per Item"
//                                         onChange={handleInputChange}
//                                         onWheel={(e) => e.target.blur()}
//                                         value={formData.rate_per_item}
//                                         className={`form-input width-10vw ${errors.rate_per_item ? "error" : inputState.tile ? "success" : ""
//                                             }`}
//                                     />
//                                     {errors.rate_per_item && (
//                                         <span className="error-message font-size-text ">{errors.rate_per_item}</span>
//                                     )}
//                                 </div>
//                                 <div className="flex-column">
//                                     <label htmlFor="total" className="form-labels  font-weight500    font-size-subheading" title='Rate per Item'>
//                                         Total Amount<span className="required">(Read-Only)</span>
//                                     </label>
//                                     <input
//                                         type="number"
//                                         min={0}
//                                         id="total"
//                                         name="total"
//                                         title="Rate per Item"
//                                         placeholder=" Rate per Item"
//                                         onChange={handleInputChange}
//                                         onWheel={(e) => e.target.blur()}
//                                         value={formData.rate_per_item * formData.quantity}
//                                         className={`form-input width-10vw ${errors.total ? "error" : inputState.tile ? "success" : ""
//                                             }`}
//                                     />
//                                     {errors.total && (
//                                         <span className="error-message font-size-text ">{errors.total}</span>
//                                     )}
//                                 </div>

//                                 <div className="flex-column">
//                                     <label htmlFor="purchase_date" className="form-labels  font-weight500    font-size-subheading" title="Purchase Date">
//                                         Purchase date
//                                         {/* <span className="required">*</span> */}
//                                     </label>
//                                     <input
//                                         type="date"
//                                         id="purchase_date"
//                                         title="Purchase Date"
//                                         name="purchase_date"
//                                         placeholder="purchase_date"
//                                         max={new Date().toISOString().split("T")[0]}   // 👈 blocks future dates
//                                         onChange={handleInputChange}
//                                         value={formData.purchase_date}
//                                         className={`form-input width-10vw ${errors.purchase_date ? "error" : inputState.purchase_date ? "success" : ""
//                                             }`}
//                                     />

//                                     {errors.purchase_date && (
//                                         <span className="error-message font-size-text ">{errors.purchase_date}</span>
//                                     )}
//                                 </div>
//                                 <div className="flex-column ">
//                                     <label className="form-labels font-weight500    announce-date font-weight400  font-size-heading">Attachment
//                                     </label>
//                                     <div style={{ width: "54vw" }} className={`file-upload-container flex-row justify-between file-in-upload ${errors.file ? 'error' : inputState.file ? 'success' : ''}`}>
//                                         <label style={{ cursor: 'pointer' }} htmlFor="upload_attachment">
//                                             <Attachment />

//                                             <span className="form-text-trasformation-uppercase" style={{ marginLeft: "20px" }}>
//                                                 {docNames ? docNames : 'No file selected'}
//                                             </span>
//                                         </label>
//                                         <input
//                                             id="upload_attachment"
//                                             name="upload_attachment"
//                                             type="file"
//                                             accept=".pdf,.doc,.docx,.xls,.xlsx"
//                                             onChange={handleFileChange}
//                                             style={{ display: "none", position: "relative" }}
//                                         />

//                                         {formData.upload_attachment ? (<span className="file-clear" onClick={() => handleFileClear('upload_attachment')}>
//                                             Clear
//                                         </span>) : null}
//                                     </div>

//                                 </div>
//                             </div>

//                             <div className="button-models">
//                                 <button className="model-button-cancel model-button   font-weight500   " onClick={handleClose}>
//                                     Cancel
//                                 </button>
//                                 <button
//                                     className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
//                                     onClick={handleFormSubmit}
//                                     disabled={loading}
//                                 >
//                                     Add
//                                 </button>
//                             </div>
//                         </div>
//                         <p className="error-message font-size-text">
//                             {isSubmitted && Object.keys(errors).length > 0 && (
//                                 Object.keys(errors).length > 5 ? (
//                                     <h5 className="text-center">Please fill all mandatory fields!</h5>
//                                 ) : (

//                                     <h6 className="text-center">
//                                         {Object.keys(errors).map((field) =>
//                                             field.charAt(0).toUpperCase() + field.slice(1)
//                                         ).join(', ') + ' are required!'}
//                                     </h6>
//                                 )
//                             )}
//                         </p>
//                     </div>
//                     {/* <ToastContainer position='top-center' autoClose={3000} hideProgressBar /> */}
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// };


const AddSiteInventory = ({ getInventory, p_id }) => {
    const [show, setShow] = useState(false);
    const [projectList, setProjectList] = useState([]);
    const projectID = sessionStorage.getItem('sitemanagement_project')

    const role = sessionStorage.getItem('sitemanagement_role');
    const siteRole = sessionStorage.getItem("sitemanagement_role");
    const siteempId = sessionStorage.getItem("sitemanagement_emp_id");

    const [activeSection, setActiveSection] = useState('project');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [tabValidationAttempted, setTabValidationAttempted] = useState({});

    const sections = [
        { id: 'project', label: 'Project & Employee', icon: Briefcase },
        { id: 'items', label: 'Item Details', icon: Package },
        { id: 'billing', label: 'Quantity & Rate', icon: IndianRupee },
        { id: 'attachment', label: 'Attachment', icon: Paperclip },
    ];

    // Which fields belong to which tab — used for per-tab validation
    const tabRequiredFields = {
        project: ["project"],
        items: ["item_id_multiple", "description"],
        billing: ["quantity", "rate_per_item"],
        attachment: [],
    };

    const initialFormData = {
        item_id: "",
        emp_code: null,
        project: projectID ? projectID : p_id ? p_id : "null",
        description: "",
        quantity: "",
        rate_per_item: "",
        upload_attachment: "null",
        item_id_multiple: [],
        purchase_date: null,
    };

    const handleClose = () => {
        setShow(false);
        setErrors({});
        setTabValidationAttempted({});
        setActiveSection('project');
        setFormData(initialFormData);
        setDocNames("");
    };

    const handleShow = () => {
        getEmployee();
        getItem();
        setErrors({});
        setTabValidationAttempted({});
        setActiveSection('project');
        setShow(true);
    };

    const [formData, setFormData] = useState(initialFormData);
    const [status, setStatus] = useState(0);

    const getProjectdata = async () => {
        try {
            const resUrl = await axios.get(`${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${siteRole === "AuthorityEngineer" ? siteempId : "null"}/null/${siteRole === "DataEntryOperator" ? siteempId : "null"}/null/`);
            setProjectList(resUrl.data);
            setStatus(resUrl.status)
        } catch (error) {
            toast.error(error)
        }
    };

    useEffect(() => {
        if (show === true && projectList.length === 0) {
            getProjectdata();
        }
    }, [siteRole, show, siteempId, projectList]);

    const [itemlist, setItemList] = useState([]);

    const getItem = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const pro = await axios.get(`${BASE_URL}/siteproject/siteinventoryitem/`);
            setItemList(pro.data);
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    }

    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "description",
            "quantity",
            "rate_per_item",
            "project",
        ];
        if (formData.item_id_multiple.length === 0) {
            newErrors.item_id_multiple = `Item is required field`
        }
        if (formData.purchase_date) {
            const selectedDate = new Date(formData.purchase_date);
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const selectedDateObj = new Date(selectedDate);
            selectedDateObj.setHours(0, 0, 0, 0);

            if (selectedDateObj > today) {
                newErrors.purchase_date = "Future date is not allowed";
            }
        }

        requiredFields.forEach((field) => {
            if (!formData[field] || formData[field] === "null") {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    // Validate only the fields belonging to the current tab
    const validateCurrentTab = () => {
        const currentTab = activeSection;
        const newErrors = {};
        const fieldsToValidate = tabRequiredFields[currentTab] || [];

        fieldsToValidate.forEach((field) => {
            if (field === "item_id_multiple") {
                if (formData.item_id_multiple.length === 0) {
                    newErrors.item_id_multiple = `Item is required field`;
                }
                return;
            }
            const value = formData[field];
            if (value === "" || value === null || value === undefined || value === "null") {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
            }
        });

        setErrors((prev) => ({ ...prev, ...newErrors }));

        // Clear errors for fields in this tab that are now filled
        setErrors((prev) => {
            const updated = { ...prev };
            fieldsToValidate.forEach((field) => {
                if (field === "item_id_multiple") {
                    if (formData.item_id_multiple.length > 0) delete updated.item_id_multiple;
                    return;
                }
                if (formData[field] && formData[field] !== "null") delete updated[field];
            });
            return updated;
        });

        setTabValidationAttempted((prev) => ({ ...prev, [currentTab]: true }));

        return Object.keys(newErrors).length === 0;
    };

    const hasCurrentTabErrors = () => {
        const currentTab = activeSection;
        const fieldsToValidate = tabRequiredFields[currentTab] || [];
        return fieldsToValidate.some((field) => errors[field]);
    };

    const getCurrentTabErrorMessage = () => {
        const currentTab = activeSection;
        const missingFields = (tabRequiredFields[currentTab] || [])
            .filter((field) => {
                if (field === "item_id_multiple") return formData.item_id_multiple.length === 0;
                return !formData[field] || formData[field] === "null";
            })
            .map((field) => field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' '));

        if (missingFields.length === 0 && !hasCurrentTabErrors()) return null;
        if (missingFields.length === 1) return `${missingFields[0]} is required to proceed`;
        if (missingFields.length > 1) return `Please fill all required fields in ${sections.find(s => s.id === currentTab)?.label} before proceeding`;
        return `Please fix the errors in this section before proceeding`;
    };

    // Does a given tab have any missing required field? (for the warning dot)
    const tabHasMissingFields = (tabId) => {
        const fieldsToValidate = tabRequiredFields[tabId] || [];
        return fieldsToValidate.some((field) => {
            if (field === "item_id_multiple") return formData.item_id_multiple.length === 0;
            return !formData[field] || formData[field] === "null";
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "purchase_date") {
            const today = new Date().toISOString().split("T")[0];

            if (value > today) {
                setErrors({
                    ...errors,
                    purchase_date: "Future date is not allowed",
                });
                return;
            }
        }

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: value,
            };

            if (name === "emp_code") {
                const selectedprojectList = projectList.find(emp => emp.emp_code === value);
                if (selectedprojectList) {
                    updatedFormData.name = selectedprojectList.name;
                } else {
                    updatedFormData.name = null;
                }
            }

            return updatedFormData;
        });

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (value.trim()) {
                delete updatedErrors[name];
            }
            return updatedErrors;
        });
    };

    const [employeeList, setEmployeeList] = useState([]);

    const getEmployee = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const pro = await axios.get(`${BASE_URL}/siteproject/employeefilterbyproject/${formData.project}/null/`);
            setEmployeeList(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    useEffect(() => {
        getEmployee(formData.project);
    }, [formData.project]);

    const [buffer, setBuffering] = useState(true); //buffering logic

    //******************Valedation End*********************** */

    const [loading, setLoading] = useState(false);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setShowProgressModal(true);
        setLoading(true);
        setUploadProgress(0);

        const loadingToastId = toast.loading("Loading: Please wait...");

        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            if (progress >= 100) {
                progress = 100;
                clearInterval(interval);
            }
            setUploadProgress(progress);
        }, 100);

        try {
            const payload = new FormData();

            formData.item_id_multiple.forEach((id) => {
                payload.append("item_id_multiple", id);
            });
            payload.append("emp_code", formData.emp_code || null);
            payload.append("project", formData.project);
            payload.append("description", formData.description);
            payload.append("quantity", formData.quantity);
            payload.append("rate_per_item", formData.rate_per_item);
            payload.append("purchase_date", formData.purchase_date || null);

            if (formData.upload_attachment) {
                payload.append("upload_attachment", formData.upload_attachment);
            }

            const res = await axios.post(
                `${BASE_URL}/siteproject/siteinventory/`,
                payload,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (res.status === 200) {
                await getInventory();
                toast.dismiss(loadingToastId);
                toast.success("Item Added Successfully");
                handleClose();
            } else {
                toast.dismiss(loadingToastId);
                toast.error("Failed to add data!");
            }
        } catch (err) {
            clearInterval(interval);
            setUploadProgress(0);
            toast.dismiss(loadingToastId);
            handleErrorToast(err);
        } finally {
            clearInterval(interval);
            setTimeout(() => {
                setShowProgressModal(false);
            }, 1500);
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const projectOptions = projectList
        ?.sort((a, b) =>
            a.project_short_name.localeCompare(b.project_short_name, "en", {
                ignorePunctuation: true,
            })
        )
        .map((i) => ({
            value: i.id,
            label: `${i.site_prcode} ${i.project_short_name}`,
        }));

    const itemOptions = itemlist
        ?.sort((a, b) =>
            a.item_name.localeCompare(b.item_name, "en", {
                ignorePunctuation: true,
            })
        )
        .map((i) => ({
            value: i.id,
            label: i.item_name,
        }));

    const employeeOptions = employeeList
        ?.sort((a, b) =>
            a.emp_code.localeCompare(b.emp_code, "en", {
                ignorePunctuation: true,
            })
        )
        .map((i) => ({
            value: i.id,
            label: `${i.emp_code} - ${i.name}`,
        }));

    const [docNames, setDocNames] = useState();

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            const symbols = "!@#$%^&*()_-+=";
            const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
            const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            const numbers = "0123456789";
            const now = new Date();
            const date = now
                .toLocaleDateString("en-GB")
                .split("/")
                .reverse()
                .join("-"); // Format: YYYY-MM-DD
            const time = now
                .toLocaleTimeString("en-GB", { hour12: false })
                .replace(/:/g, "-"); // Format: HH-MM-SS
            const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
            let randomCode = "";
            for (let i = 0; i < 8; i++) {
                const randomIndex = Math.floor(Math.random() * allChars.length);
                randomCode += allChars[randomIndex];
            }
            const customFileName = `Aimantra ${date} ${time}_${randomCode} ${file.name}`;
            const customFile = new File([file], customFileName, { type: file.type });

            setFormData({
                ...formData,
                upload_attachment: customFile,
            });
            setDocNames(customFileName);
        } else {
            setDocNames("");
        }
    };

    const handleFileClear = () => {
        setFormData({
            ...formData,
            upload_attachment: null,
        });
        setDocNames("");
    };

    const Option = (props) => (
        <components.Option {...props}>
            <label title="Star" className="star">
                <input id="star-checkbox" checked={props.isSelected}
                    onChange={() => null} className="checkbox" type="checkbox" />
                <div className="svg-container">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-outline"
                        viewBox="0 0 24 24"
                    >
                        <path
                            d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5ZM12 4.75L14 9.33L18.7 9.75L15 13.07L16.18 17.75L12 15.16L7.82 17.75L9 13.07L5.3 9.75L10 9.33L12 4.75Z"
                        ></path>
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-filled"
                        viewBox="0 0 24 24"
                    >
                        <path
                            d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5Z"
                        ></path>
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="100"
                        width="100"
                        className="svg-celebrate"
                    >
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                    </svg>
                </div>
            </label>
            {props.label}
        </components.Option>
    );

    const MenuList = (props) => {
        const { options, selectProps } = props;

        const filteredOptions = options.filter(
            (opt) => opt.label.toLowerCase() !== "other"
        );

        const selectedValues = selectProps.value?.map((i) => i.value) || [];
        const filteredValues = filteredOptions.map((i) => i.value);

        const isAllSelected = filteredValues.every((val) =>
            selectedValues.includes(val)
        );

        const handleToggle = () => {
            if (isAllSelected) {
                const preserveOther = selectProps.value?.filter(
                    (i) => i.label.toLowerCase() === "other"
                ) || [];
                selectProps.onChange(preserveOther);
            } else {
                const preserveOther = selectProps.value?.filter(
                    (i) => i.label.toLowerCase() === "other"
                ) || [];
                selectProps.onChange([...filteredOptions, ...preserveOther]);
            }
        }

        return (
            <components.MenuList {...props}>
                <button
                    type="button"
                    onClick={handleToggle}
                    style={{
                        width: "100%",
                        padding: "6px 0",
                        cursor: "pointer",
                        fontWeight: "600",
                        borderBottom: "1px solid #e3e3e3",
                        background: "white"
                    }}
                >
                    {isAllSelected ? "Unselect All" : "Select All"}
                </button>

                {props.children}
            </components.MenuList>
        );
    };

    const handleChangecc = (selected) => {
        const item_id_multiple =
            selected && selected.length > 0 ? selected.map((item) => item.value) : [];
        setFormData((prevState) => ({
            ...prevState,
            item_id_multiple,
        }));
        setErrors((prev) => {
            const updated = { ...prev };
            if (item_id_multiple.length > 0) delete updated.item_id_multiple;
            return updated;
        });
    };

    useEffect(() => {
        if (formData.project) {
            setFormData(prev => ({
                ...prev,
                emp_code: null,
            }));
        }
    }, [formData.project]);

    // Tab switch — validates current tab first, blocks switch on failure
    const handleTabSwitch = (targetTabId) => {
        if (activeSection === targetTabId) return;
        const modalBody = document.querySelector('.modern-modal-body');
        if (validateCurrentTab()) {
            setActiveSection(targetTabId);
            if (modalBody) modalBody.scrollTop = 0;
        } else {
            if (modalBody) modalBody.scrollTop = 0;
        }
    };

    const goToNextTab = () => {
        const currentIndex = sections.findIndex(s => s.id === activeSection);
        const nextTab = sections[currentIndex + 1]?.id;
        if (!nextTab) return;
        handleTabSwitch(nextTab);
    };
    const goToPreviousTab = () => {
        const currentIndex = sections.findIndex(s => s.id === activeSection);
        if (currentIndex > 0) setActiveSection(sections[currentIndex - 1].id);
    };

    const renderProjectSection = () => (
        <div className="form-section">
            <div className="section-title">
                <Briefcase size={18} />
                <h4>Project & Employee</h4>
            </div>
            <div className="form-grid">
                <div className="form-field">
                    <label><Briefcase size={14} /> Site Project <span className="required">{(role === "SiteManagement" || p_id) ? "(Read-Only)" : "*"}</span></label>
                    {status === 200 ? (
                        <Select
                            name="project"
                            isDisabled={(role === "SiteManagement" || p_id) ? true : false}
                            placeholder="Select a Project"
                            value={projectOptions?.find(
                                (option) => option.value === formData.project
                            )}
                            onChange={(selectedOption) => {
                                setFormData({
                                    ...formData,
                                    project: selectedOption ? selectedOption.value : "null",
                                });
                                setInputState({
                                    ...inputState,
                                    project: selectedOption ? "green" : "",
                                });
                                setErrors((prev) => {
                                    const updated = { ...prev };
                                    if (selectedOption) delete updated.project;
                                    return updated;
                                });
                            }}
                            styles={CSSForSelectModern}
                            options={projectOptions}
                            isSearchable
                            isClearable
                        />
                    ) : (
                        <div className="loader" style={{ width: "100%" }}>
                            <div className="child"></div>
                        </div>
                    )}
                    {errors.project && <span className="error-message">Site {errors.project}</span>}
                </div>

                {formData.project !== "null" && (
                    <div className="form-field">
                        <label><User size={14} /> Employee</label>
                        <Select
                            name="emp_code"
                            placeholder="Select an Employee"
                            value={
                                employeeOptions?.find(
                                    (option) => option.value === formData.emp_code
                                ) || null
                            }
                            onChange={(selectedOption) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    emp_code: selectedOption ? selectedOption.value : null,
                                }));
                                setInputState((prev) => ({
                                    ...prev,
                                    emp_code: selectedOption ? "green" : "",
                                }));
                            }}
                            options={employeeOptions}
                            isSearchable
                            isClearable
                            styles={CSSForSelectModern}
                        />
                        {errors.emp_code && <span className="error-message">{errors.emp_code}</span>}
                    </div>
                )}
            </div>

            <div className="section-navigation-buttons nav-buttons-wrapper">
                {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
                    <div className="tab-error-message">
                        <AlertCircle size={14} />
                        <span>{getCurrentTabErrorMessage()}</span>
                    </div>
                )}
                {(!tabValidationAttempted[activeSection] || !hasCurrentTabErrors()) && <div></div>}
                <button type="button" className="btn-next" onClick={goToNextTab}>
                    Next: Item Details <ChevronRight size={16} />
                </button>
            </div>
        </div>
    );

    const renderItemsSection = () => (
        <div className="form-section">
            <div className="section-title">
                <Package size={18} />
                <h4>Item Details</h4>
            </div>
            <div className="form-grid">
                <div className="form-field full-width">
                    <label><Package size={14} /> List of Items<span className="required">*</span></label>
                    <Select
                        options={itemOptions}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        placeholder="Select Items"
                        onChange={handleChangecc}
                        styles={CSSForSelectModern}
                    />
                    {errors.item_id_multiple && <span className="error-message">Required field!</span>}
                </div>

                <div className="form-field full-width">
                    <label><FileText size={14} /> Description<span className="required">*</span></label>
                    <input
                        type="text"
                        name="description"
                        placeholder="Description"
                        onChange={handleInputChange}
                        value={formData.description}
                        className={errors.description ? "error" : inputState.description ? "success" : ""}
                    />
                    {errors.description && <span className="error-message">{errors.description}</span>}
                </div>
            </div>

            <div className="section-navigation-buttons dual-buttons">
                <div className="nav-buttons-wrapper">
                    <button type="button" className="btn-prev" onClick={goToPreviousTab}>
                        <ChevronRight size={16} className="rotate-left" /> Previous
                    </button>
                    {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
                        <div className="tab-error-message">
                            <AlertCircle size={14} />
                            <span>{getCurrentTabErrorMessage()}</span>
                        </div>
                    )}
                    <button type="button" className="btn-next" onClick={goToNextTab}>
                        Next: Quantity & Rate <ChevronRight size={16} />
                    </button>
                </div>
            </div>
        </div>
    );

    const renderBillingSection = () => (
        <div className="form-section">
            <div className="section-title">
                <IndianRupee size={18} />
                <h4>Quantity & Rate</h4>
            </div>
            <div className="form-grid">
                <div className="form-field">
                    <label><Hash size={14} /> Quantity<span className="required">*</span></label>
                    <input
                        type="number"
                        min={0}
                        name="quantity"
                        placeholder="Quantity"
                        onChange={handleInputChange}
                        onWheel={(e) => e.target.blur()}
                        value={formData.quantity}
                        className={errors.quantity ? "error" : inputState.quantity ? "success" : ""}
                    />
                    {errors.quantity && <span className="error-message">{errors.quantity}</span>}
                </div>

                <div className="form-field">
                    <label><IndianRupee size={14} /> Rate per Item<span className="required">*</span></label>
                    <input
                        type="number"
                        min={0}
                        name="rate_per_item"
                        placeholder="Rate per Item"
                        onChange={handleInputChange}
                        onWheel={(e) => e.target.blur()}
                        value={formData.rate_per_item}
                        className={errors.rate_per_item ? "error" : inputState.rate_per_item ? "success" : ""}
                    />
                    {errors.rate_per_item && <span className="error-message">{errors.rate_per_item}</span>}
                </div>

                <div className="form-field">
                    <label><IndianRupee size={14} /> Total Amount<span className="required">(Read-Only)</span></label>
                    <input
                        type="number"
                        disabled
                        value={(Number(formData.rate_per_item) || 0) * (Number(formData.quantity) || 0)}
                        className="readonly-field"
                    />
                </div>

                <div className="form-field">
                    <label><Calendar size={14} /> Purchase Date</label>
                    <input
                        type="date"
                        name="purchase_date"
                        max={new Date().toISOString().split("T")[0]}
                        onChange={handleInputChange}
                        value={formData.purchase_date || ""}
                        className={errors.purchase_date ? "error" : inputState.purchase_date ? "success" : ""}
                    />
                    {errors.purchase_date && <span className="error-message">{errors.purchase_date}</span>}
                </div>
            </div>

            <div className="section-navigation-buttons dual-buttons">
                <div className="nav-buttons-wrapper">
                    <button type="button" className="btn-prev" onClick={goToPreviousTab}>
                        <ChevronRight size={16} className="rotate-left" /> Previous
                    </button>
                    {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
                        <div className="tab-error-message">
                            <AlertCircle size={14} />
                            <span>{getCurrentTabErrorMessage()}</span>
                        </div>
                    )}
                    <button type="button" className="btn-next" onClick={goToNextTab}>
                        Next: Attachment <ChevronRight size={16} />
                    </button>
                </div>
            </div>
        </div>
    );

    const renderAttachmentSection = () => (
        <div className="form-section">
            <div className="section-title">
                <Paperclip size={18} />
                <h4>Attachment</h4>
            </div>
            <div className="form-grid">
                <div className="form-field full-width">
                    <label><Paperclip size={14} /> Attachment</label>
                    <div className={`file-upload-container flex-row justify-between file-in-upload ${errors.file ? 'error' : inputState.file ? 'success' : ''}`}>
                        <label style={{ cursor: 'pointer' }} htmlFor="upload_attachment">
                            <Attachment />
                            <span style={{ marginLeft: "20px" }}>
                                {docNames ? docNames : 'No file selected'}
                            </span>
                        </label>
                        <input
                            id="upload_attachment"
                            name="upload_attachment"
                            type="file"
                            accept=".pdf,.doc,.docx,.xls,.xlsx"
                            onChange={handleFileChange}
                            style={{ display: "none", position: "relative" }}
                        />
                        {formData.upload_attachment ? (
                            <span className="file-clear" onClick={handleFileClear}>
                                Clear
                            </span>
                        ) : null}
                    </div>
                </div>
            </div>

            <div className="form-actions">
                <button type="button" className="btn-prev" onClick={goToPreviousTab}>
                    <ChevronRight size={16} className="rotate-left" /> Previous: Quantity & Rate
                </button>
                <div className="submit-buttons">
                    <button type="button" className="btn-secondaryy" onClick={handleClose}>
                        Cancel
                    </button>
                    <button type="button" className="btn-primaryy" onClick={handleFormSubmit} disabled={loading}>
                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                        <span>{loading ? 'Adding...' : 'Add Item'}</span>
                    </button>
                </div>
            </div>

            <p className="error-message" style={{ marginTop: '12px' }}>
                {isSubmitted && Object.keys(errors).length > 0 && (
                    Object.keys(errors).length > 5 ? (
                        <span>Please fill all mandatory fields!</span>
                    ) : (
                        Object.keys(errors).map((field) => field.charAt(0).toUpperCase() + field.slice(1)).join(', ') + ' are required!'
                    )
                )}
            </p>
        </div>
    );
    const renderCurrentSection = () => {
        switch (activeSection) {
            case 'project': return renderProjectSection();
            case 'items': return renderItemsSection();
            case 'billing': return renderBillingSection();
            case 'attachment': return renderAttachmentSection();
            default: return renderProjectSection();
        }
    };

    return (
        <>
            <AddDynamicButton title="Site Inventory" logo={<Package size={24} />} onClick={handleShow} />

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Package size={24} />
                            </div>
                            <div>
                                <Modal.Title>Add Site Inventory</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Fill in the details to add a new inventory item</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

                    <Modal.Body className="modern-modal-body">
                        <div className="section-navigation">
                            {sections.map((section) => {
                                const Icon = section.icon;
                                const showWarning = tabValidationAttempted[activeSection] && tabHasMissingFields(section.id) && section.id !== activeSection;
                                return (
                                    <button
                                        key={section.id}
                                        className={`section-nav-btn ${activeSection === section.id ? 'active' : ''} ${showWarning ? 'has-warning' : ''}`}
                                        onClick={() => handleTabSwitch(section.id)}
                                    >
                                        <Icon size={16} />
                                        <span>{section.label}</span>
                                        {showWarning && <div className="warning-dot" title="Missing required fields" />}
                                        {activeSection === section.id && <ChevronRight size={14} className="nav-arrow" />}
                                    </button>
                                );
                            })}
                        </div>

                        <form onSubmit={handleFormSubmit} className="project-form">
                            <div key={activeSection}>
                                {renderCurrentSection()}
                            </div>

                        </form>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};
const UpdateSiteInventory = ({ i, getInventory }) => {
    const [show, setShow] = useState(false);
    const [projectList, setProjectList] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [activeSection, setActiveSection] = useState('project');
    const [tabValidationAttempted, setTabValidationAttempted] = useState({});

    const role = sessionStorage.getItem('sitemanagement_role');
    const siteRole = sessionStorage.getItem("sitemanagement_role");
    const siteempId = sessionStorage.getItem("sitemanagement_emp_id");
    const projectID = sessionStorage.getItem('sitemanagement_project');

    const sections = [
        { id: 'project', label: 'Project & Employee', icon: Briefcase },
        { id: 'items', label: 'Item Details', icon: Package },
        { id: 'billing', label: 'Quantity & Rate', icon: IndianRupee },
        { id: 'attachment', label: 'Attachment', icon: Paperclip },
    ];

    const buildFormDataFromI = () => ({
        project: i.project || "null",
        emp_code: i.emp_code || null,
        description: i.description || "",
        quantity: i.quantity || "",
        rate_per_item: i.rate_per_item || "",
        upload_attachment: i.upload_attachment || null,
        item_id_multiple: i.item_id_multiple || [],
        purchase_date: i.purchase_date || null,
    });

    const [formData, setFormData] = useState(buildFormDataFromI());
    const [docNames, setDocNames] = useState(i.upload_attachment ? i.upload_attachment.split('/').pop() : "");

    const handleShow = () => {
        setFormData(buildFormDataFromI());
        setDocNames(i.upload_attachment ? i.upload_attachment.split('/').pop() : "");
        setActiveSection('project');
        setTabValidationAttempted({});
        setErrors({});
        getEmployee();
        getItem();
        setShow(true);
    };

    const handleClose = (event) => {
        if (event) event.preventDefault();
        setShow(false);
        setFormData(buildFormDataFromI());
        setActiveSection('project');
        setTabValidationAttempted({});
        setErrors({});
    };

    const [status, setStatus] = useState(0);

    const getProjectdata = async () => {
        try {
            const resUrl = await axios.get(`${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${siteRole === "AuthorityEngineer" ? siteempId : "null"}/null/${siteRole === "DataEntryOperator" ? siteempId : "null"}/null/`);
            setProjectList(resUrl.data);
            setStatus(resUrl.status);
        } catch (error) {
            toast.error(error);
        }
    };

    useEffect(() => {
        if (show === true && projectList.length === 0) {
            getProjectdata();
        }
    }, [siteRole, show, siteempId, projectList]);

    const [itemlist, setItemList] = useState([]);
    const getItem = async () => {
        setBuffering(true);
        try {
            const pro = await axios.get(`${BASE_URL}/siteproject/siteinventoryitem/`);
            setItemList(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    const [employeeList, setEmployeeList] = useState([]);
    const getEmployee = async () => {
        setBuffering(true);
        try {
            const pro = await axios.get(`${BASE_URL}/siteproject/employeefilterbyproject/${formData.project}/null/`);
            setEmployeeList(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };
    useEffect(() => {
        if (show === true) getEmployee();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.project, show]);

    const [buffer, setBuffering] = useState(true);

    // !  ************** Validation start **************  ! //
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const fieldLabels = {
        project: 'Site Project',
        item_id_multiple: 'List of Items',
        description: 'Description',
        quantity: 'Quantity',
        rate_per_item: 'Rate per Item',
        purchase_date: 'Purchase Date',
    };

    const getTabRequiredFields = (tabId) => {
        const map = {
            project: ['project'],
            items: ['item_id_multiple', 'description'],
            billing: ['quantity', 'rate_per_item'],
            attachment: [],
        };
        return map[tabId] || [];
    };

    const isFieldEmpty = (field, data = formData) => {
        if (field === 'item_id_multiple') return !data.item_id_multiple || data.item_id_multiple.length === 0;
        const value = data[field];
        return value === null || value === undefined || value === "null" || (typeof value === 'string' && value.trim() === "");
    };

    const tabHasMissingFields = (tabId) => getTabRequiredFields(tabId).some((field) => isFieldEmpty(field));

    const validateCurrentTab = () => {
        const currentTab = activeSection;
        const fieldsToValidate = getTabRequiredFields(currentTab);
        const newErrors = {};

        fieldsToValidate.forEach((field) => {
            if (isFieldEmpty(field)) {
                newErrors[field] = `${fieldLabels[field] || field} is required!`;
            }
        });

        // Extra: purchase date can't be in the future
        if (currentTab === 'billing' && formData.purchase_date) {
            const selected = new Date(formData.purchase_date);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            selected.setHours(0, 0, 0, 0);
            if (selected > today) newErrors.purchase_date = "Future date is not allowed";
        }

        setErrors(prev => {
            const updated = { ...prev, ...newErrors };
            fieldsToValidate.forEach((field) => {
                if (!isFieldEmpty(field) && field !== 'purchase_date') delete updated[field];
            });
            if (currentTab === 'billing' && !newErrors.purchase_date) delete updated.purchase_date;
            return updated;
        });

        setTabValidationAttempted(prev => ({ ...prev, [currentTab]: true }));

        return Object.keys(newErrors).length === 0;
    };

    const hasCurrentTabErrors = () => getTabRequiredFields(activeSection).some(field => errors[field]) || (activeSection === 'billing' && errors.purchase_date);

    const getCurrentTabErrorMessage = () => {
        const missingFields = getTabRequiredFields(activeSection)
            .filter(field => isFieldEmpty(field))
            .map(field => fieldLabels[field] || field);

        if (missingFields.length === 0 && !hasCurrentTabErrors()) return null;
        if (missingFields.length === 1) return `${missingFields[0]} is required to proceed`;
        if (missingFields.length > 1) {
            const tabLabel = sections.find(s => s.id === activeSection)?.label || activeSection;
            return `Please fill all required fields in ${tabLabel} before proceeding`;
        }
        return `Please fix the errors in this section before proceeding`;
    };

    const goToNextTab = () => {
        const currentIndex = sections.findIndex(s => s.id === activeSection);
        const nextTab = sections[currentIndex + 1]?.id;

        if (!validateCurrentTab()) {
            const formContainer = document.querySelector('.modern-modal-body');
            if (formContainer) formContainer.scrollTop = 0;
            return;
        }

        if (nextTab) setActiveSection(nextTab);
    };

    const goToPreviousTab = () => {
        const idx = sections.findIndex(s => s.id === activeSection);
        if (idx > 0) setActiveSection(sections[idx - 1].id);
    };

    const validateForm = () => {
        const newErrors = {};
        sections.forEach((section) => {
            getTabRequiredFields(section.id).forEach((field) => {
                if (isFieldEmpty(field)) {
                    newErrors[field] = `${fieldLabels[field] || field} is required!`;
                }
            });
        });

        if (formData.purchase_date) {
            const selected = new Date(formData.purchase_date);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            selected.setHours(0, 0, 0, 0);
            if (selected > today) newErrors.purchase_date = "Future date is not allowed";
        }

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "purchase_date") {
            const today = new Date().toISOString().split("T")[0];
            if (value > today) {
                setErrors({ ...errors, purchase_date: "Future date is not allowed" });
                setFormData(prev => ({ ...prev, purchase_date: value }));
                return;
            }
        }

        setFormData((prev) => ({ ...prev, [name]: value }));
        setInputState((prev) => ({ ...prev, [name]: value?.toString().trim() ? "green" : "" }));

        if (value?.toString().trim()) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };
    // ?  ************** Validation End **************  ! //

    const [loading, setLoading] = useState(false);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setShowProgressModal(true);
            setLoading(true);
            setUploadProgress(0);

            const loadingToastId = toast.loading("Loading: Please wait...");

            let progress = 0;
            const interval = setInterval(() => {
                progress += 10;
                if (progress >= 100) {
                    progress = 100;
                    clearInterval(interval);
                }
                setUploadProgress(progress);
            }, 100);

            try {
                const payload = new FormData();
                formData.item_id_multiple.forEach((id) => {
                    payload.append("item_id_multiple", id);
                });
                payload.append("emp_code", formData.emp_code || null);
                payload.append("project", formData.project);
                payload.append("description", formData.description);
                payload.append("quantity", formData.quantity);
                payload.append("rate_per_item", formData.rate_per_item);
                payload.append("purchase_date", formData.purchase_date || null);

                if (formData.upload_attachment instanceof File) {
                    payload.append("upload_attachment", formData.upload_attachment);
                }

                const res = await axios.put(
                    `${BASE_URL}/siteproject/siteinventory/${i.id}/`,
                    payload,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );

                if (res.status === 200) {
                    await getInventory();
                    clearInterval(interval);
                    toast.dismiss(loadingToastId);
                    toast.success("Updated Successfully");
                    handleClose();
                }
            } catch (err) {
                clearInterval(interval);
                setUploadProgress(0);
                handleErrorToast(err);
            } finally {
                clearInterval(interval);
                setTimeout(() => {
                    setShowProgressModal(false);
                }, 1500);
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        } else {
            const firstErrorTab = sections.find(s => tabHasMissingFields(s.id))?.id;
            if (firstErrorTab) {
                setActiveSection(firstErrorTab);
                setTabValidationAttempted(prev => ({ ...prev, [firstErrorTab]: true }));
            }
        }
    };

    const projectOptions = projectList
        ?.sort((a, b) => a.project_short_name.localeCompare(b.project_short_name, "en", { ignorePunctuation: true }))
        .map((p) => ({ value: p.id, label: `${p.site_prcode} ${p.project_short_name}` }));

    const itemOptions = itemlist
        ?.sort((a, b) => a.item_name.localeCompare(b.item_name, "en", { ignorePunctuation: true }))
        .map((it) => ({ value: it.id, label: it.item_name }));

    const employeeOptions = employeeList
        ?.sort((a, b) => a.emp_code.localeCompare(b.emp_code, "en", { ignorePunctuation: true }))
        .map((e) => ({ value: e.id, label: `${e.emp_code} - ${e.name}` }));

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const symbols = "!@#$%^&*()_-+=";
            const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
            const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            const numbers = "0123456789";
            const now = new Date();
            const date = now.toLocaleDateString("en-GB").split("/").reverse().join("-");
            const time = now.toLocaleTimeString("en-GB", { hour12: false }).replace(/:/g, "-");
            const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
            let randomCode = "";
            for (let idx = 0; idx < 8; idx++) {
                randomCode += allChars[Math.floor(Math.random() * allChars.length)];
            }
            const customFileName = `Aimantra ${date} ${time}_${randomCode} ${file.name}`;
            const customFile = new File([file], customFileName, { type: file.type });

            setFormData((prev) => ({ ...prev, upload_attachment: customFile }));
            setDocNames(customFileName);
        } else {
            setDocNames("");
        }
    };

    const handleFileClear = () => {
        setFormData((prev) => ({ ...prev, upload_attachment: null }));
        setDocNames("");
    };

    const Option = (props) => (
        <components.Option {...props}>
            <label title="Star" className="star">
                <input id="star-checkbox" checked={props.isSelected} onChange={() => null} className="checkbox" type="checkbox" />
                <div className="svg-container">
                    <svg xmlns="http://www.w3.org/2000/svg" className="svg-outline" viewBox="0 0 24 24">
                        <path d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5ZM12 4.75L14 9.33L18.7 9.75L15 13.07L16.18 17.75L12 15.16L7.82 17.75L9 13.07L5.3 9.75L10 9.33L12 4.75Z"></path>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" className="svg-filled" viewBox="0 0 24 24">
                        <path d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5Z"></path>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" height="100" width="100" className="svg-celebrate">
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                        <circle r="2" cy="50" cx="50" className="particle"></circle>
                    </svg>
                </div>
            </label>
            {props.label}
        </components.Option>
    );

    const MenuList = (props) => {
        const { options, selectProps } = props;
        const filteredOptions = options.filter((opt) => opt.label.toLowerCase() !== "other");
        const selectedValues = selectProps.value?.map((v) => v.value) || [];
        const filteredValues = filteredOptions.map((v) => v.value);
        const isAllSelected = filteredValues.every((val) => selectedValues.includes(val));

        const handleToggle = () => {
            const preserveOther = selectProps.value?.filter((v) => v.label.toLowerCase() === "other") || [];
            if (isAllSelected) {
                selectProps.onChange(preserveOther);
            } else {
                selectProps.onChange([...filteredOptions, ...preserveOther]);
            }
        };

        return (
            <components.MenuList {...props}>
                <button
                    type="button"
                    onClick={handleToggle}
                    style={{ width: "100%", padding: "6px 0", cursor: "pointer", fontWeight: "600", borderBottom: "1px solid #e3e3e3", background: "white" }}
                >
                    {isAllSelected ? "Unselect All" : "Select All"}
                </button>
                {props.children}
            </components.MenuList>
        );
    };

    const handleChangecc = (selected) => {
        const item_id_multiple = selected && selected.length > 0 ? selected.map((item) => item.value) : [];
        setFormData((prevState) => ({ ...prevState, item_id_multiple }));
        setErrors((prev) => {
            const updated = { ...prev };
            if (item_id_multiple.length > 0) delete updated.item_id_multiple;
            return updated;
        });
    };

    const renderProjectSection = () => (
        <div className="form-section">
            <div className="section-title">
                <Briefcase size={18} />
                <h4>Project & Employee</h4>
            </div>
            <div className="form-grid">
                <div className="form-field">
                    <label><Briefcase size={14} /> Site Project<span className="required">{role === "SiteManagement" ? "(Read-Only)" : "*"}</span></label>
                    {status === 200 ? (
                        <Select
                            isDisabled={role === "SiteManagement"}
                            placeholder="Select a Project"
                            value={projectOptions?.find((option) => option.value === formData.project)}
                            onChange={(selectedOption) => {
                                setFormData((prev) => ({ ...prev, project: selectedOption ? selectedOption.value : "null" }));
                                setInputState((prev) => ({ ...prev, project: selectedOption ? "green" : "" }));
                                setErrors((prev) => {
                                    const updated = { ...prev };
                                    if (selectedOption) delete updated.project;
                                    return updated;
                                });
                            }}
                            styles={CSSForSelectModern}
                            options={projectOptions}
                            isSearchable
                            isClearable
                        />
                    ) : (
                        <div className="loader" style={{ width: "100%" }}>
                            <div className="child"></div>
                        </div>
                    )}
                    {errors.project && <span className="error-message">{errors.project}</span>}
                </div>

                {formData.project !== "null" && (
                    <div className="form-field">
                        <label><User size={14} /> Employee</label>
                        <Select
                            placeholder="Select an Employee"
                            value={employeeOptions?.find((option) => option.value === formData.emp_code) || null}
                            onChange={(selectedOption) => {
                                setFormData((prev) => ({ ...prev, emp_code: selectedOption ? selectedOption.value : null }));
                                setInputState((prev) => ({ ...prev, emp_code: selectedOption ? "green" : "" }));
                            }}
                            options={employeeOptions}
                            isSearchable
                            isClearable
                            styles={CSSForSelectModern}
                        />
                        {errors.emp_code && <span className="error-message">{errors.emp_code}</span>}
                    </div>
                )}
            </div>

            <div className="section-navigation-buttons nav-buttons-wrapper">
                {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
                    <div className="tab-error-message">
                        <AlertCircle size={14} />
                        <span>{getCurrentTabErrorMessage()}</span>
                    </div>
                )}
                {(!tabValidationAttempted[activeSection] || !hasCurrentTabErrors()) && <div></div>}
                <button type="button" className="btn-next" onClick={goToNextTab} disabled={tabHasMissingFields('project')}>
                    Next: Item Details <ChevronRight size={16} />
                </button>
            </div>
        </div>
    );

    const renderItemsSection = () => (
        <div className="form-section">
            <div className="section-title">
                <Package size={18} />
                <h4>Item Details</h4>
            </div>
            <div className="form-grid">
                <div className="form-field full-width">
                    <label><Package size={14} /> List of Items<span className="required">*</span></label>
                    <Select
                        options={itemOptions}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{ Option, MenuList }}
                        placeholder="Select Items"
                        value={itemOptions?.filter((opt) => formData.item_id_multiple?.includes(opt.value))}
                        onChange={handleChangecc}
                        styles={CSSForSelectModern}
                    />
                    {errors.item_id_multiple && <span className="error-message">Required field!</span>}
                </div>

                <div className="form-field full-width">
                    <label><FileText size={14} /> Description<span className="required">*</span></label>
                    <input
                        type="text"
                        name="description"
                        placeholder="Description"
                        onChange={handleInputChange}
                        value={formData.description}
                        className={errors.description ? "error" : inputState.description ? "success" : ""}
                    />
                    {errors.description && <span className="error-message">{errors.description}</span>}
                </div>
            </div>

            <div className="section-navigation-buttons dual-buttons">
                <div className="nav-buttons-wrapper">
                    <button type="button" className="btn-prev" onClick={goToPreviousTab}>
                        <ChevronRight size={16} className="rotate-left" /> Previous
                    </button>
                    {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
                        <div className="tab-error-message">
                            <AlertCircle size={14} />
                            <span>{getCurrentTabErrorMessage()}</span>
                        </div>
                    )}
                    <button type="button" className="btn-next" onClick={goToNextTab} disabled={tabHasMissingFields('items')}>
                        Next: Quantity & Rate <ChevronRight size={16} />
                    </button>
                </div>
            </div>
        </div>
    );

    const renderBillingSection = () => (
        <div className="form-section">
            <div className="section-title">
                <IndianRupee size={18} />
                <h4>Quantity & Rate</h4>
            </div>
            <div className="form-grid">
                <div className="form-field">
                    <label><Hash size={14} /> Quantity<span className="required">*</span></label>
                    <input
                        type="number"
                        min={0}
                        name="quantity"
                        placeholder="Quantity"
                        onChange={handleInputChange}
                        onWheel={(e) => e.target.blur()}
                        value={formData.quantity}
                        className={errors.quantity ? "error" : inputState.quantity ? "success" : ""}
                    />
                    {errors.quantity && <span className="error-message">{errors.quantity}</span>}
                </div>

                <div className="form-field">
                    <label><IndianRupee size={14} /> Rate per Item<span className="required">*</span></label>
                    <input
                        type="number"
                        min={0}
                        name="rate_per_item"
                        placeholder="Rate per Item"
                        onChange={handleInputChange}
                        onWheel={(e) => e.target.blur()}
                        value={formData.rate_per_item}
                        className={errors.rate_per_item ? "error" : inputState.rate_per_item ? "success" : ""}
                    />
                    {errors.rate_per_item && <span className="error-message">{errors.rate_per_item}</span>}
                </div>

                <div className="form-field">
                    <label><IndianRupee size={14} /> Total Amount<span className="required">(Read-Only)</span></label>
                    <input
                        type="number"
                        disabled
                        value={(Number(formData.rate_per_item) || 0) * (Number(formData.quantity) || 0)}
                        className="readonly-field"
                    />
                </div>

                <div className="form-field">
                    <label><Calendar size={14} /> Purchase Date</label>
                    <input
                        type="date"
                        name="purchase_date"
                        max={new Date().toISOString().split("T")[0]}
                        onChange={handleInputChange}
                        value={formData.purchase_date || ""}
                        className={errors.purchase_date ? "error" : inputState.purchase_date ? "success" : ""}
                    />
                    {errors.purchase_date && <span className="error-message">{errors.purchase_date}</span>}
                </div>
            </div>

            <div className="section-navigation-buttons dual-buttons">
                <div className="nav-buttons-wrapper">
                    <button type="button" className="btn-prev" onClick={goToPreviousTab}>
                        <ChevronRight size={16} className="rotate-left" /> Previous
                    </button>
                    {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
                        <div className="tab-error-message">
                            <AlertCircle size={14} />
                            <span>{getCurrentTabErrorMessage()}</span>
                        </div>
                    )}
                    <button type="button" className="btn-next" onClick={goToNextTab} disabled={tabHasMissingFields('billing')}>
                        Next: Attachment <ChevronRight size={16} />
                    </button>
                </div>
            </div>
        </div>
    );

    const renderAttachmentSection = () => (
        <div className="form-section">
            <div className="section-title">
                <Paperclip size={18} />
                <h4>Attachment</h4>
            </div>
            <div className="form-grid">
                <div className="form-field full-width">
                    <label><Paperclip size={14} /> Attachment</label>
                    <div className={`file-upload-container flex-row justify-between file-in-upload ${errors.file ? 'error' : inputState.file ? 'success' : ''}`}>
                        <label style={{ cursor: 'pointer' }} htmlFor="upload_attachment_update">
                            <Attachment />
                            <span style={{ marginLeft: "20px" }}>
                                {docNames ? docNames : 'No file selected'}
                            </span>
                        </label>
                        <input
                            id="upload_attachment_update"
                            name="upload_attachment"
                            type="file"
                            accept=".pdf,.doc,.docx,.xls,.xlsx"
                            onChange={handleFileChange}
                            style={{ display: "none", position: "relative" }}
                        />
                        {formData.upload_attachment ? (
                            <span className="file-clear" onClick={handleFileClear}>
                                Clear
                            </span>
                        ) : null}
                    </div>
                </div>
            </div>

            <div className="form-actions">
                <button type="button" className="btn-prev" onClick={goToPreviousTab}>
                    <ChevronRight size={16} className="rotate-left" /> Previous: Quantity & Rate
                </button>
                <div className="submit-buttons">
                    <button type="button" className="btn-secondaryy" onClick={handleClose}>
                        Cancel
                    </button>
                    <button type="submit" className="btn-primaryy" disabled={loading || tabHasMissingFields('billing') || tabHasMissingFields('items') || tabHasMissingFields('project')}>
                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                        <span>{loading ? 'Updating...' : 'Update'}</span>
                    </button>
                </div>
            </div>

            {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
                <div className="tab-error-message" style={{ marginTop: '12px' }}>
                    <AlertCircle size={14} />
                    <span>{getCurrentTabErrorMessage()}</span>
                </div>
            )}
        </div>
    );

    const renderCurrentSection = () => {
        switch (activeSection) {
            case 'project': return renderProjectSection();
            case 'items': return renderItemsSection();
            case 'billing': return renderBillingSection();
            case 'attachment': return renderAttachmentSection();
            default: return renderProjectSection();
        }
    };

    return (
        <div>
            <button title="Update Site Inventory" className="model-edit-button-modern actionn-icon" style={{ background: "#00000075" }} onClick={handleShow}>
                <UpdatePencil modernButton="true" />
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Package size={24} />
                            </div>
                            <div>
                                <Modal.Title>Update Site Inventory</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Update the details of this inventory item</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body">
                        <div className="section-navigation">
                            {sections.map((section) => {
                                const Icon = section.icon;
                                const hasMissing = tabHasMissingFields(section.id);
                                return (
                                    <button
                                        key={section.id}
                                        className={`section-nav-btn ${activeSection === section.id ? 'active' : ''} ${hasMissing && section.id !== activeSection ? 'has-warning' : ''}`}
                                        onClick={() => {
                                            if (activeSection !== section.id) {
                                                if (validateCurrentTab()) {
                                                    setActiveSection(section.id);
                                                } else {
                                                    const formContainer = document.querySelector('.modern-modal-body');
                                                    if (formContainer) formContainer.scrollTop = 0;
                                                }
                                            }
                                        }}
                                    >
                                        <Icon size={16} />
                                        <span>{section.label}</span>
                                        {hasMissing && section.id !== activeSection && (
                                            <div className="warning-dot" title="Missing required fields" />
                                        )}
                                        {activeSection === section.id && <ChevronRight size={14} className="nav-arrow" />}
                                    </button>
                                );
                            })}
                        </div>

                        <form onSubmit={handleFormSubmit} className="project-form">
                            <div key={activeSection}>
                                {renderCurrentSection()}
                            </div>
                        </form>

                        <p className="error-message" style={{ marginTop: '12px' }}>
                            {!isSubmitted && Object.keys(errors).length > 5 && (
                                <span>Please fill all mandatory fields!</span>
                            )}
                        </p>

                        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                    </Modal.Body>
                </Modal>
            )}
        </div>
    );
};


const SiteInventoryDelete = ({ i, getInventory }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        setShowProgressModal(true);
        setLoading(true);
        setUploadProgress(0);

        const loadingToastId = toast.loading("Loading: Please wait...");

        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            if (progress >= 100) {
                progress = 100;
                clearInterval(interval);
            }
            setUploadProgress(progress);
        }, 100);

        try {
            let res = await axios.delete(`${BASE_URL}/siteproject/siteinventory/${i.id}/`);

            if (res.status === 200) {
                await getInventory();
                toast.dismiss(loadingToastId);
                toast.success("Deleted Successfully");
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {
            clearInterval(interval);
            setUploadProgress(0);
            handleErrorToast(err);
        } finally {
            clearInterval(interval);
            setTimeout(() => {
                setShowProgressModal(false);
            }, 1500);
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button title="Delete Inventory Item" className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#fff"
                    />
                </svg>
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-required-modal" centered>
                    <Modal.Header className="modern-modal-header requirement-modal-header">
                        <div className="header-content">
                            <div className="requirement-header-icon">
                                <Trash2 size={22} />
                            </div>
                            <div>
                                <Modal.Title>Delete Inventory Item</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>
                                    This action cannot be undone
                                </p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body requirement-modal-body">
                        <div className="requirement-mode-summary" style={{ marginBottom: '20px' }}>
                            <AlertCircle size={16} />
                            <span>
                                Are you sure you want to delete <strong>{i.item_name}</strong>, given to <strong>{i.employee_emp_code}</strong>?
                            </span>
                        </div>

                        <div className="submit-buttons" style={{ justifyContent: 'flex-end' }}>
                            <button type="button" className="btn-secondaryy" onClick={handleClose} disabled={loading}>
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn-primaryy"
                                style={{ background: "#dc3545", borderColor: "#dc3545" }}
                                onClick={handleFormSubmitDelete}
                                disabled={loading}
                            >
                                {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
                                <span>{loading ? 'Deleting...' : 'Delete'}</span>
                            </button>
                        </div>

                        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

// !  **************  Inventory Components End **************  ! //
const AddItemList = ({ getItemsList, list }) => {
    const [show, setShow] = useState(false);
    const [subCompanyList, setSubCompanyList] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const initialFormData = {
        item_name: "",
        sub_company: "",
    };

    const [formData, setFormData] = useState(initialFormData);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isduplicate, setIsduplicate] = useState(false);
    const [loading, setLoading] = useState(false);
    const [buffer, setBuffering] = useState(true); //buffering logic

    const handleClose = () => {
        setShow(false);
        setErrors({});
        setIsSubmitted(false);
        setFormData(initialFormData);
        setInputState({});
    };

    const handleShow = () => {
        getSubCompany();
        setErrors({});
        setIsSubmitted(false);
        setShow(true);
    };

    //******************Valedation Start********************* */

    const getSubCompany = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(res.data);
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        if (show === true && formData.sub_company) {
            const subfilter = list.filter((i) => i.sub_company === formData.sub_company);
            const filter = subfilter.filter((i) => i.item_name === formData.item_name);

            if (filter.length !== 0) {
                setIsduplicate(true);
                setTimeout(() => {
                    toast.warn("Item already exists in data", {
                        autoClose: 1000,
                        pauseOnHover: true,
                        closeOnClick: true,
                    });
                }, 1000);
            } else {
                setIsduplicate(false);
            }
        }
    }, [list, formData.item_name, show, formData.sub_company]);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["item_name"];

        if (isduplicate === true) {
            newErrors.isduplicate = " Duplicate item !";
            setTimeout(() => {
                toast.error("Duplicate Data Found !", {
                    autoClose: 1000,
                    pauseOnHover: true,
                    closeOnClick: true,
                });
            }, 1000);
        }

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (value.trim()) {
                delete updatedErrors[name];
            }
            return updatedErrors;
        });
    };

    //******************Valedation End*********************** */

    const subCompanyOptions = subCompanyList
        ?.sort((a, b) =>
            a.title.localeCompare(b.title, "en", {
                ignorePunctuation: true,
            })
        )
        .map((i) => ({
            value: i.id,
            label: i.title,
        }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setShowProgressModal(true);
        setLoading(true);
        setUploadProgress(0);

        const loadingToastId = toast.loading("Loading: Please wait...");

        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            if (progress >= 100) {
                progress = 100;
                clearInterval(interval);
            }
            setUploadProgress(progress);
        }, 100);

        try {
            const res = await axios.post(`${BASE_URL}/siteproject/siteinventoryitem/`, formData);

            if (res.status === 200) {
                await getItemsList();
                toast.dismiss(loadingToastId);
                toast.success("Item added successfully", {
                    autoClose: 1000,
                    pauseOnHover: true,
                    closeOnClick: true,
                });
                handleClose();
            } else {
                toast.dismiss(loadingToastId);
                toast.error("Failed to add item!");
            }
        } catch (err) {
            clearInterval(interval);
            setUploadProgress(0);
            toast.dismiss(loadingToastId);
            handleErrorToast(err);
        } finally {
            clearInterval(interval);
            setTimeout(() => {
                setShowProgressModal(false);
            }, 1500);
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <AddDynamicButton title="Items" logo={<Tag size={24} />} onClick={handleShow} />

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="lg">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Tag size={24} />
                            </div>
                            <div>
                                <Modal.Title>Add Item</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>
                                    Fill in the details to add a new item
                                </p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar />

                    <Modal.Body className="modern-modal-body">
                        <form onSubmit={handleSubmit} className="project-form">
                            <div className="form-section">
                                <div className="section-title">
                                    <Tag size={18} />
                                    <h4>Item Details</h4>
                                </div>

                                <div className="form-grid">
                                    <div className="form-field">
                                        <label>
                                            <Briefcase size={14} /> Site Sub Company
                                        </label>
                                        {!buffer ? (
                                            <Select
                                                name="sub_company"
                                                placeholder="Select a Site SubCompany"
                                                value={
                                                    subCompanyOptions?.find(
                                                        (option) => option.value === formData.sub_company
                                                    ) || null
                                                }
                                                onChange={(selectedOption) => {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        sub_company: selectedOption ? selectedOption.value : "",
                                                    }));
                                                    setInputState((prev) => ({
                                                        ...prev,
                                                        sub_company: selectedOption ? "green" : "",
                                                    }));
                                                    setErrors((prev) => {
                                                        const updated = { ...prev };
                                                        if (selectedOption) delete updated.sub_company;
                                                        return updated;
                                                    });
                                                }}
                                                styles={CSSForSelectModern}
                                                options={subCompanyOptions}
                                                isSearchable
                                                isClearable
                                            />
                                        ) : (
                                            <div className="loader" style={{ width: "100%" }}>
                                                <div className="child"></div>
                                            </div>
                                        )}
                                        {errors.sub_company && (
                                            <span className="error-message">{errors.sub_company}</span>
                                        )}
                                    </div>

                                    <div className="form-field">
                                        <label>
                                            <Package size={14} /> Item Name<span className="required">*</span>
                                        </label>
                                        <input
                                            id="item_name"
                                            type="text"
                                            name="item_name"
                                            title="Add Item Name"
                                            maxLength={50}
                                            placeholder="Item Name"
                                            onChange={handleInputChange}
                                            value={formData.item_name}
                                            className={
                                                errors.item_name
                                                    ? "error"
                                                    : inputState.item_name
                                                        ? "success"
                                                        : ""
                                            }
                                        />
                                        {errors.item_name && (
                                            <span className="error-message">{errors.item_name}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="form-actions">
                                    <div className="submit-buttons">
                                        <button
                                            type="button"
                                            className="btn-secondaryy"
                                            onClick={handleClose}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn-primaryy"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <Loader size={18} className="spinning" />
                                            ) : (
                                                <Save size={18} />
                                            )}
                                            <span>{loading ? "Adding..." : "Add"}</span>
                                        </button>
                                    </div>
                                </div>

                                <p className="error-message" style={{ marginTop: "12px" }}>
                                    {isSubmitted &&
                                        Object.keys(errors).length > 0 &&
                                        (Object.keys(errors).length > 2 ? (
                                            <span>Please fill all mandatory fields!</span>
                                        ) : (
                                            Object.keys(errors)
                                                .map((field) => field.charAt(0).toUpperCase() + field.slice(1))
                                                .join(", ") + " are required!"
                                        ))}
                                </p>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

const UpdateItemList = ({ i, getItemsList, list }) => {
    const [show, setShow] = useState(false);
    const [subCompanyList, setSubCompanyList] = useState([]);
    const [loading, setLoading] = useState(false);

    const buildFormDataFromI = () => ({
        item_name: i.item_name || "",
        sub_company: i.sub_company || "",
    });

    const [formData, setFormData] = useState(buildFormDataFromI());

    const handleShow = () => {
        setFormData(buildFormDataFromI());
        setErrors({});
        setInputState({});
        setIsSubmitted(false);
        getSubCompany();
        setShow(true);
    };

    const handleClose = (event) => {
        if (event) event.preventDefault();
        setShow(false);
        setFormData(buildFormDataFromI());
        setErrors({});
        setInputState({});
    };

    const getSubCompany = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(res.data);
        } catch (err) {
            handleErrorToast(err);
        }
    };

    // !  ************** Validation start **************  ! //
    const [isduplicate, setIsduplicate] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const fieldLabels = {
        item_name: 'Item Name',
        sub_company: 'Site Sub Company',
    };

    useEffect(() => {
        if (show === true && formData.sub_company) {
            const subfilter = list.filter((li) => li.sub_company === formData.sub_company);
            const filter = subfilter.filter((li) => li.item_name === formData.item_name);

            if (filter.length !== 0) {
                if (formData.item_name !== i.item_name) {
                    setIsduplicate(true);
                    setTimeout(() => {
                        toast.warn("Item already exists in data", {
                            autoClose: 1000,
                            pauseOnHover: true,
                            closeOnClick: true,
                        });
                    }, 1000);
                }
            } else {
                setIsduplicate(false);
            }
        }
    }, [list, formData.item_name, show, formData.sub_company, i]);

    const isFieldEmpty = (field, data = formData) => {
        const value = data[field];
        return value === null || value === undefined || (typeof value === 'string' && value.trim() === "");
    };

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["item_name"];

        requiredFields.forEach((field) => {
            if (isFieldEmpty(field)) {
                newErrors[field] = `${fieldLabels[field] || field} is required!`;
            }
        });

        if (isduplicate === true) {
            newErrors.item_name = "Duplicate item already exists!";
            setTimeout(() => {
                toast.error("Duplicate Data Found !", {
                    autoClose: 1000,
                    pauseOnHover: true,
                    closeOnClick: true,
                });
            }, 1000);
        }

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({ ...prev, [name]: value }));
        setInputState((prev) => ({ ...prev, [name]: value?.toString().trim() ? "green" : "" }));

        if (value?.toString().trim()) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };
    // ?  ************** Validation End **************  ! //

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true);
            const loadingToastId = toast.loading("Loading: Please wait...");

            try {
                const res = await axios.put(
                    `${BASE_URL}/siteproject/siteinventoryitem/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getItemsList();
                    toast.dismiss(loadingToastId);
                    toast.success("Data updated successfully", {
                        autoClose: 1000,
                        pauseOnHover: true,
                        closeOnClick: true,
                    });
                    handleClose();
                } else {
                    toast.dismiss(loadingToastId);
                    toast.error("Failed to add data!");
                }
            } catch (err) {
                toast.dismiss(loadingToastId);
                handleErrorToast(err);
            } finally {
                toast.dismiss(loadingToastId);
                setLoading(false);
            }
        }
    };

    const subCompanyOptions = subCompanyList
        ?.slice()
        .sort((a, b) => a.title.localeCompare(b.title, "en", { ignorePunctuation: true }))
        .map((sc) => ({ value: sc.id, label: sc.title }));

    return (
        <div>
            <button title="Update Item" className="model-edit-button-modern actionn-icon" style={{ background: "#00000075" }} onClick={handleShow}>
                <UpdatePencil modernButton="true" />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="md">
                <Modal.Header className="modern-modal-header">
                    <div className="header-content">
                        <div style={{ color: "white" }}>
                            <Package size={24} />
                        </div>
                        <div>
                            <Modal.Title>Update Item</Modal.Title>
                            <p className="header-subtitle" style={{ color: "white" }}>Update the details of this inventory item</p>
                        </div>
                    </div>
                    <button className="close-btn" onClick={handleClose}>
                        <X size={20} />
                    </button>
                </Modal.Header>

                <Modal.Body className="modern-modal-body">
                    <form onSubmit={handleSubmit} className="project-form">
                        <div className="form-section">
                            <div className="section-title">
                                <Package size={18} />
                                <h4>Item Details</h4>
                            </div>
                            <div className="form-grid">
                                <div className="form-field">
                                    <label><Building2 size={14} /> Site Sub Company</label>
                                    <Select
                                        inputId="sub_company"
                                        name="sub_company"
                                        placeholder="Select a Site SubCompany"
                                        value={subCompanyOptions?.find((option) => option.value === formData.sub_company) || null}
                                        onChange={(selectedOption) => {
                                            const value = selectedOption ? selectedOption.value : "";
                                            setFormData((prev) => ({ ...prev, sub_company: value }));
                                            setInputState((prev) => ({ ...prev, sub_company: selectedOption ? "green" : "" }));
                                            setErrors((prev) => {
                                                const updated = { ...prev };
                                                if (selectedOption) delete updated.sub_company;
                                                return updated;
                                            });
                                        }}
                                        options={subCompanyOptions}
                                        styles={CSSForSelectModern}
                                        isSearchable
                                        isClearable
                                    />
                                    {errors.sub_company && <span className="error-message">{errors.sub_company}</span>}
                                </div>

                                <div className="form-field">
                                    <label><Tag size={14} /> Item Name<span className="required">*</span></label>
                                    <input
                                        id="item_name"
                                        type="text"
                                        name="item_name"
                                        placeholder="Item Name"
                                        onChange={handleInputChange}
                                        value={formData.item_name}
                                        className={errors.item_name ? "error" : inputState.item_name ? "success" : ""}
                                    />
                                    {errors.item_name && <span className="error-message">{errors.item_name}</span>}
                                </div>
                            </div>

                            <div className="form-actions">
                                <div></div>
                                <div className="submit-buttons">
                                    <button type="button" className="btn-secondaryy" onClick={handleClose}>
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn-primaryy" disabled={loading}>
                                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                                        <span>{loading ? 'Updating...' : 'Update'}</span>
                                    </button>
                                </div>
                            </div>

                            {isSubmitted && Object.keys(errors).length > 0 && (
                                <div className="tab-error-message" style={{ marginTop: '12px' }}>
                                    <AlertCircle size={14} />
                                    <span>Please fill all mandatory fields!</span>
                                </div>
                            )}
                        </div>
                    </form>

                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </div>
    );
};


const DeleteItemList = ({ i, getItemsList }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/siteinventoryitem/${i.id}/`
            );

            if (res.status === 200) {
                await getItemsList();
                toast.dismiss(loadingToastId);
                toast.success("Deleted Successfully");
                setShow(false);
            } else {
                toast.dismiss(loadingToastId);
                toast.error("Failed to add data!");
            }
        } catch (err) {
            toast.dismiss(loadingToastId);
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button title="Delete Item" className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#fff"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="modern-required-modal" centered>
                <Modal.Header className="modern-modal-header requirement-modal-header">
                    <div className="header-content">
                        <div className="requirement-header-icon">
                            <Trash2 size={22} />
                        </div>
                        <div>
                            <Modal.Title>Delete Item</Modal.Title>
                            <p className="header-subtitle" style={{ color: "white" }}>
                                This action cannot be undone
                            </p>
                        </div>
                    </div>
                    <button className="close-btn" onClick={handleClose}>
                        <X size={20} />
                    </button>
                </Modal.Header>

                <Modal.Body className="modern-modal-body requirement-modal-body">
                    <div className="requirement-mode-summary" style={{ marginBottom: '20px' }}>
                        <AlertCircle size={16} />
                        <span>
                            Are you sure you want to delete item <strong>{i.item_name}</strong>?
                        </span>
                    </div>

                    <div className="submit-buttons" style={{ justifyContent: 'flex-end' }}>
                        <button type="button" className="btn-secondaryy" onClick={handleClose} disabled={loading}>
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn-primaryy"
                            style={{ background: "#dc3545", borderColor: "#dc3545" }}
                            onClick={handleFormSubmitDelete}
                            disabled={loading}
                        >
                            {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
                            <span>{loading ? 'Deleting...' : 'Delete'}</span>
                        </button>
                    </div>

                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const SiteInventory = ({ p_id, site_prcode, siteData, getSiteInventoryData, ischild }) => {
    const [siteInventory, setSiteInventory] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedSearch, setSearch] = useState("");
    const [expandedRow, setExpandedRow] = useState(null);
    const [showFilters, setShowFilters] = useState(true);

    const projectID = sessionStorage.getItem('sitemanagement_project')

    const [selectedProject, setSelectedProject] = useState(projectID ? projectID : "null");
    const [projectList, setProjectList] = useState([]);
    const role = sessionStorage.getItem("sitemanagement_role");

    const [buffer, setBuffering] = useState(true); //buffering logic

    const getProjects = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const pro = await axios.get(
                sessionStorage.getItem('sitemanagement_role') === 'AuthorityEngineer' ?
                    `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem('sitemanagement_emp_id')}/`
                    : sessionStorage.getItem('sitemanagement_role') === 'DataEntryOperator' ?
                        `${BASE_URL}/siteproject/projectfilterbycom_operator/${sessionStorage.getItem('sitemanagement_emp_id')}/`
                        : `${BASE_URL}/siteproject/project/`
            );
            const sortedProjects = sortProjects(pro.data, 'site_prcode');
            setProjectList(sortedProjects);

        } catch (err) {
            //toast Logic
            if (err.response) {
                const errorData = err.response.data;

                if (typeof errorData.error === 'string') {
                    toast.error(`Error: ${errorData.error}`);
                } else if (typeof errorData === 'object' && errorData !== null) {
                    Object.entries(errorData).forEach(([field, messages]) => {
                        messages.forEach(message => toast.error(`"${field}": ${message}`));
                    });
                } else {
                    toast.error('Error:- Failed to Process!');
                }
            } else {
                toast.error('Error processing your request.');
            }
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    const getInventory = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/filterbyproj-site-inventory/${p_id ? p_id : selectedProject}/`);
            setSiteInventory(res.data);
        } catch (err) {
            // handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getProjects();
    }, [selectedProject, p_id]);

    useEffect(() => {
        getInventory();
    }, [selectedProject, p_id]);

    const applyFilters = () => {
        let filteredData = siteInventory;
        if (selectedSearch !== "") {
            const lowercaseSelectedName = selectedSearch?.toLowerCase();
            filteredData = filteredData.filter(project => {
                const item_name = project?.item_name?.toString()?.toLowerCase().includes(lowercaseSelectedName);
                return item_name;
            });
        }
        if (selectedProject !== 'null') {
            filteredData = filteredData.filter(project => project.project === selectedProject);
        }

        setFilteredData(filteredData);
    };

    useEffect(() => {
        applyFilters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedSearch, siteInventory]);

    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    const displayData = role === "SiteManagement" ? siteData : filteredData;

    const showFilterBar = !p_id && role !== "SiteManagement";
    const hasActiveFilters = selectedProject !== "null" || selectedSearch !== "";

    const clearAllFilters = () => {
        setSelectedProject("null");
        setSearch("");
    };

    const columnCount = (p_id ? 8 : 9) + (role !== "Checker" && role !== "ViewAccess" ? 1 : 0);

    return (
        <div className="progress-modern-container">

            {p_id && (
                <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                    <div className="jd-heading-outer-flex">
                        <h2 className="jd-heading-main font-weight600 font-size-heading">Site Inventory</h2>
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        {role !== "ViewAccess" &&
                            <AddSiteInventory getInventory={getInventory} p_id={p_id} projectID={projectID} />
                        }
                        {role === "Admin" &&
                            <UploadInventory getInventory={getInventory} site_prcode={site_prcode} />
                        }
                    </div>
                </div>
            )}

            {showFilters && showFilterBar && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">
                        {role === "Admin" &&
                            <div className={`filter-chip ${selectedProject !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: "0px" }}>
                                <div className="filter-chip-content">
                                    <Projects usedFor="filter" value="id" toggleProject={selectedProject} setToggleProject={setSelectedProject} subcompany="null" />
                                </div>
                            </div>
                        }

                        <div className="filter-chip" style={{ minWidth: '260px' }}>
                            <div><Search size={15} /></div>
                            <div className="filter-chip-content" style={{ width: '100%' }}>
                                <input
                                    className="modern-select"
                                    style={{ width: '100%' }}
                                    placeholder="Search Item"
                                    value={selectedSearch}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                        </div>

                        {hasActiveFilters && role === "Admin" && (
                            <button className="clear-filters-btn" onClick={clearAllFilters}>
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Stats + toggle + actions */}
            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <Package size={14} />
                        <span>Showing</span>
                        <strong>{displayData?.length || 0} items</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                    {showFilterBar && (
                        <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
                            <Filter size={14} />
                            <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                            {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                        </button>
                    )}

                    {!p_id && role !== "Checker" && role !== "ViewAccess" && role !== "SiteManagement" && (
                        <div className="filter-actions-attractive" style={{ display: 'flex', gap: '8px' }}>
                            <AddSiteInventory getInventory={getInventory} projectID={projectID} />
                            {role === "Admin" &&
                                <UploadInventory getInventory={getInventory} />
                            }
                        </div>
                    )}
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading" style={{ zIndex: 1000 }}>
                            <tr>
                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                {!p_id && <th className="col-period" style={{ width: '13%' }}>Project</th>}
                                <th className="col-period text-center">Item Details</th>
                                <th className="col-submitted text-center" style={{ width: '10%' }}>Quantity</th>
                                <th className="col-submitted text-center" style={{ width: '12%' }}>Total Amount</th>
                                <th className="col-approved text-center" style={{ width: '10%' }}>Document</th>
                                <th className="col-status text-center" style={{ width: '10%' }}>Purchase Date</th>
                                {role !== "Checker" && role !== "ViewAccess" && <th className="col-action text-center" style={{ width: '12%' }}>Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {displayData?.map((i, index) => {
                                const isExpanded = expandedRow === index;
                                return (
                                    <React.Fragment key={index}>
                                        <tr className="progress-row">
                                            <td className="col-sno text-start">{index + 1}.</td>
                                            {!p_id && <td className="col-period">{i.project_short_name}</td>}
                                            <td className="col-period">
                                                <div className="flex-row" style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                    <button className="period-trigger" style={{ width: "60%", textAlign: 'left', justifyContent: 'center' }} onClick={() => toggleRow(index)}>
                                                        <Package size={12} />
                                                        <span>
                                                            {i.item_id_multiple.length !== 0
                                                                ? i.item_names_details.join(", ")
                                                                : i.item_name}
                                                        </span>
                                                        {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                    </button>
                                                </div>
                                            </td>
                                            <td className="col-submitted text-center">
                                                <span className="badge-value">{i.quantity}</span>
                                            </td>
                                            <td className="col-submitted text-center">
                                                <span className="badge-value">₹{formatCurrencyIndian(Number(i.rate_per_item) * Number(i.quantity))}</span>
                                            </td>
                                            <td className="col-approved text-center">
                                                {i.upload_attachment ? (
                                                    <a href={i.upload_attachment} target="_blank" rel="noreferrer">
                                                        <div className="flex-row justify-center">
                                                            <DocumentfOLDIcon />
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <span className="empty-value">-</span>
                                                )}
                                            </td>
                                            <td className="col-status text-center">
                                                {i.purchase_date ? formattedDateLong(i.purchase_date) : "-"}
                                            </td>
                                            {role !== "Checker" && role !== "ViewAccess" && (
                                                <td className="col-action">
                                                    <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                                                        {i.lock === false &&
                                                            <UpdateSiteInventory i={i} getInventory={getInventory} />
                                                        }
                                                        {role === "Admin" &&
                                                            <Lock apiName="siteinventory" id={i.id} i={i} usedFor="Inventory" getData={getInventory} />
                                                        }
                                                        {(role === "Admin" || role === "AuthoritySupervisor" || role !== "SiteManagement") && i.lock === false && (
                                                            <SiteInventoryDelete i={i} getInventory={getInventory} />
                                                        )}
                                                    </div>
                                                </td>
                                            )}
                                        </tr>

                                        {isExpanded && (
                                            <tr className="expanded-row">
                                                <td colSpan={columnCount}>
                                                    <div className="expanded-content-attractive">
                                                        <div className="expanded-content-header">
                                                            <div className="expanded-content-title">
                                                                <Sparkles size={13} />
                                                                <span>Full Item Details</span>
                                                            </div>
                                                        </div>

                                                        <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap' }}>
                                                            <div className="stage-card submitted" style={{ flex: 1, minWidth: '240px' }}>
                                                                <div className="stage-header">
                                                                    <Package size={14} />
                                                                    <span>Item Info</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row"><span className="stage-label">Employee</span><span className="amount">{i?.employee_emp_code || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">Rate per Item</span><span className="amount">₹{formatCurrencyIndian(i?.rate_per_item || 0)}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">Quantity</span><span className="amount">{i?.quantity || "-"}</span></div>
                                                                    <div className="stage-row"><span className="stage-label">Purchase Date</span><span className="amount">{i?.purchase_date ? formattedDateLong(i.purchase_date) : "-"}</span></div>
                                                                </div>
                                                            </div>

                                                            {i.item_id_multiple.length !== 0 && (
                                                                <div className="stage-card recommended" style={{ flex: 1, minWidth: '240px' }}>
                                                                    <div className="stage-header">
                                                                        <Package size={14} />
                                                                        <span>Items</span>
                                                                    </div>
                                                                    <div className="stage-content">
                                                                        <ul style={{ paddingLeft: '18px', margin: 0 }}>
                                                                            {i.item_names_details.map((item, idx) => (
                                                                                <li key={idx} style={{ marginBottom: '6px', listStyleType: 'disc' }}>{item}</li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {i?.description && (
                                                            <div style={{ marginTop: '12px', padding: '10px 14px', background: '#f8fafc', borderRadius: '10px', fontSize: '12px', color: '#475569' }}>
                                                                <strong style={{ color: '#1e293b' }}>Description: </strong>{i.description}
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                            {(!displayData || displayData.length === 0) && (
                                <tr>
                                    <td colSpan={columnCount}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <Package size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No Inventory Items Found</h4>
                                            <p className="empty-state-subtitle">
                                                Try adjusting your filters or search to find what you're looking for.
                                            </p>

                                            {hasActiveFilters && role === "Admin" && (
                                                <button className="empty-state-clear-btn" onClick={clearAllFilters}>
                                                    <X size={13} />
                                                    Clear Filters
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>

            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
};

const ItemList = ({ item, listData }) => {

    const [buffer, setBuffering] = useState(true); //buffering logic
    const [empItemList, setEmpItemList] = useState([]);
    const [listmanagementdata, setListmangamentdata] = useState([listData]);
    const [showFilters, setShowFilters] = useState(true);

    const getItemsList = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/siteinventoryitem/`
            );

            setEmpItemList(res.data);
        } catch (err) {
            console.log(err)
            //toast Logic
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    const [searchQuery, setSearchQuery] = useState("");
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    useEffect(() => {
        getItemsList();
    }, []);

    const role = sessionStorage.getItem('sitemanagement_role')

    const filteredData = empItemList
        ?.filter((e) => e.item_name.toLowerCase().includes(searchQuery.toLowerCase()))
        .sort((a, b) => a.emp_code - b.emp_code);

    const hasActiveFilters = searchQuery !== "";
    const clearAllFilters = () => setSearchQuery("");

    const columnCount = 2 + (role === "Admin" || role === "ViewAccess" ? 1 : 0) + (role !== "SiteManagement" && role !== "ViewAccess" ? 1 : 0);

    return (
        <div className="progress-modern-container">

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">
                        <div className="filter-chip" style={{ minWidth: '260px' }}>
                            <div><Search size={15} /></div>
                            <div className="filter-chip-content" style={{ width: '100%' }}>
                                <input
                                    className="modern-select"
                                    style={{ width: '100%' }}
                                    placeholder="Search Item Name"
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                />
                            </div>
                        </div>

                        {hasActiveFilters && (
                            <button className="clear-filters-btn" onClick={clearAllFilters}>
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Stats + toggle + actions */}
            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <Package size={14} />
                        <span>Showing</span>
                        <strong>{filteredData?.length || 0} items</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                    <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>

                    {role === "Admin" && (
                        <div className="filter-actions-attractive" style={{ display: 'flex', gap: '8px' }}>
                            <AddItemList getItemsList={getItemsList} list={empItemList} />
                        </div>
                    )}
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading" style={{ zIndex: 1000 }}>
                            <tr>
                                <th className="col-sno" style={{ width: '8%' }}>#</th>
                                <th className="col-period text-center">Item Name</th>
                                {(role === "Admin" || role === "ViewAccess") && (
                                    <th className="col-approved text-center" style={{ width: '20%' }}>View</th>
                                )}
                                {role !== "SiteManagement" && role !== "ViewAccess" && (
                                    <th className="col-action text-center" style={{ width: '15%' }}>Action</th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData?.map((i, index) => (
                                <tr className="progress-row" key={index}>
                                    <td className="col-sno text-start">{index + 1}.</td>
                                    <td className="col-period text-center">
                                        <div className="flex-row" style={{ justifyContent: 'center', alignItems: 'center', gap: '6px' }}>
                                            <Package size={12} />
                                            <span>{i.item_name}</span>
                                        </div>
                                    </td>
                                    {(role === "Admin" || role === "ViewAccess") && (
                                        <td className="col-approved text-center">
                                            <AdminInventoryitemlist i={i} />
                                        </td>
                                    )}
                                    {role !== "SiteManagement" && role !== "ViewAccess" && (
                                        <td className="col-action">
                                            <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                                                <UpdateItemList i={i} getItemsList={getItemsList} list={empItemList} />
                                                <DeleteItemList i={i} getItemsList={getItemsList} />
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            ))}
                            {(!filteredData || filteredData.length === 0) && (
                                <tr>
                                    <td colSpan={columnCount}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <Package size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No Items Found</h4>
                                            <p className="empty-state-subtitle">
                                                Try adjusting your search to find what you're looking for.
                                            </p>

                                            {hasActiveFilters && (
                                                <button className="empty-state-clear-btn" onClick={clearAllFilters}>
                                                    <X size={13} />
                                                    Clear Filters
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>

            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
};


const InventoryManagementComponent = () => {

    const [toggleState, setToggleState] = useState(1);
    const role = sessionStorage.getItem("sitemanagement_role");
    const projectID = sessionStorage.getItem("sitemanagement_project");
    const [sitedata, setSiteData] = useState([]);
    const [empItemList, setEmpItemList] = useState([]);

    const getItemsList = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/siteinventoryitem/`
            );
            setEmpItemList(res.data);
        } catch (err) {
            console.log(err)
            //toast Logic
            handleErrorToast(err);
        } finally {

        }
    };

    const getInventory = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/filterbyproj-site-inventory/${projectID}/`);
            setSiteData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
        }
    };

    useEffect(() => {
        if (role === "SiteManagement") {
            getInventory();
            // getItemsList();
        }
    }, [projectID]);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1: return "Site Inventory";
            case 2: return "Item List";
            default: return "Site Inventory";
        }
    };

    const tabs = [
        { id: 1, label: 'Site Inventory', icon: Package },
        { id: 2, label: 'Item List', icon: Folder },
    ];

    const renderActiveComponent = () => {
        switch (toggleState) {
            case 1: return <SiteInventory siteData={sitedata} getSiteInventoryData={getInventory} ischild={false} />;
            case 2: return <ItemList item={empItemList} getItemsList={getItemsList} />;
            default: return null;
        }
    };

    return (
        <div>

            <div className="project-details-modern">
                <div className="project-content-modern">
                    {/* Modern Tabs */}
                    {role !== "Checker" &&
                        <div className="modern-tabs-container">
                            <div className="tabs-scroll" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                <div style={{ display: 'flex' }}>
                                    {tabs.map((tab) => {
                                        const Icon = tab.icon;
                                        return (
                                            <button
                                                key={tab.id}
                                                className={`modern-tab-btn ${toggleState === tab.id ? 'active' : ''}`}
                                                onClick={() => setToggleState(tab.id)}
                                            >
                                                <Icon size={16} />
                                                <span>{tab.label}</span>
                                                {toggleState === tab.id && <div className="active-indicator" />}
                                            </button>
                                        );
                                    })}
                                </div>

                                <div>
                                    {toggleState === 1 && role === "SiteManagement" && (
                                        <AddSiteInventory projectID={projectID} getInventory={getInventory} />
                                    )}
                                </div>
                            </div>
                        </div>
                    }

                    {/* Tab Content */}
                    <div className="tab-content-modern">
                        {renderActiveComponent()}
                    </div>
                </div>
            </div>
        </div>
    );
};




export { InventoryManagementComponent, AddSiteInventory, SiteInventory }